import React, { useEffect, useState, useContext, useRef } from "react";
import * as XLSX from "xlsx";
import socket from "../../socket";
import { useRolePermissions } from "../Settings/RoleContext";
import { useAuth } from "../Authentication/AuthContext";
import DatePicker from "react-datepicker";
import { format, parseISO, isValid } from "date-fns";
import { useParams } from "react-router-dom";
import "../../styles/projects/PhaseDetails.css";
import api from "../../api/axiosConfig";
import { Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { FaChevronDown } from "react-icons/fa";
import { LuCirclePlus } from "react-icons/lu";
import { CiCircleMinus } from "react-icons/ci";
import { ProjectContext } from "../../App";
import { Helmet } from "react-helmet";
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ← this is a *function*, not part of the `jsPDF` instance

const addTaskToPhase = async (phaseId, taskTemplateId, setError) => {
  try {
    if (!phaseId || !taskTemplateId) {
      throw new Error("Invalid phaseId or taskTemplateId");
    }
    const response = await api.post(`/api/addTaskTemplate-phase/${phaseId}`, {
      phase_id: phaseId,
      tasktemplate_id: taskTemplateId,
    });
    return response.data;
  } catch (error) {
    setError(error.message || "An error occurred while adding the task.");
    throw error;
  }
};

const addVariationToPhase = async (phaseId, variationData, setError) => {
  try {
    const response = await api.post(
      `/api/phase/${phaseId}/addVariation`,
      variationData
    );
    return response.data;
  } catch (error) {
    setError(error);
  }
};
const PhaseDetails = () => {
  const { phaseId, projectId } = useParams();
  const textareaRef = useRef(null);
  const { userDetails } = useAuth();
  const userID = userDetails.id;
  const { dialBoxopen, isNavBarOpen } = useContext(ProjectContext);
  const { hasPermission } = useRolePermissions();
  const [phase, setPhase] = useState(null);
  const project_start_date =
    phase?.start_date || phase?.project_start_date || null;
  const project_due_date = phase?.end_date || phase?.project_end_date || null;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [taskTemplateId, setTaskTemplateId] = useState("");
  const [taskTemplates, setTaskTemplates] = useState([]);
  const [projectTemplates, setProjectTemplates] = useState([]);
  const [tasksByPhase, setTasksByPhase] = useState([]);
  const templateName = tasksByPhase.map((t) => t.name);
  const [selectedTTaskId, setSelectedTTaskId] = useState([]);
  const [tabIndex, setTabIndex] = useState(() => {
    const storedTabIndex = localStorage.getItem("tabIndex");
    return storedTabIndex ? parseInt(storedTabIndex, 10) : 0;
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [openVariationDialog, setOpenVariationDialog] = useState(false);
  const [variationDate, setVariationDate] = useState(null);
  const [variationNo, setVariationNo] = useState("");
  const [variationName, setVariationName] = useState("");
  const [showCapsWarning, setShowCapsWarning] = useState(false);
  const [showDescriptionCapsWarning, setShowDescriptionCapsWarning] =
    useState(false);
  const [variationDescription, setVariationDescription] = useState("");
  const [selectedTaskId, setSelectedTaskId] = useState("");
  const [variationHours, setVariationHours] = useState(0);
  const [designHours, setDesignHours] = useState(0);
  const [detailingHours, setDetailingHours] = useState(0);
  const [variationTemplate, setVariationTemplate] = useState([
    { name: "", hours: "" },
  ]);
  const [variations, setVariations] = useState([]); // Initialize as an empty array
  console.log("variations", variations);
  const [selectedVariation, setSelectedVariation] = useState(null);
  const [claimStatusVariation, setClaimStatusVariation] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const variationRef = useRef(null);
  const [bulkActionVariation, setBulkActionVariation] = useState(false);
  const [deleteTaskDialogOpen, setDeleteTaskDialogOpen] = useState(false);
  const [deleteIndividualTaskDialogOpen, setIndividualDeleteTaskDialogOpen] =
    useState(false);
  const [addTaskDial, setAddTaskDial] = useState(false);
  const [taskTemplateIdToAdd, setTaskTemplateIdToAdd] = useState([]);
  const [newTask, setNewTask] = useState({ name: "" });
  const [variationToBulkUpdate, setVariationToBulkUpdate] = useState([]);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isCheckboxCheckedForTask, setIsCheckboxCheckedForTask] =
    useState(false);

  //issues props
  const issueRef = useRef(null);
  const [issues, setIssues] = useState([]);
  const [openIssueDialog, setOpenIssueDialog] = useState(false);
  const [users, setUsers] = useState([]);
  const [projectUsers, setProjectUsers] = useState([]);
  const options = projectUsers
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((user) => ({
      label: user.name,
      value: user.id,
    }));
  const [customer, setCustomer] = useState([]);
  const [issueDate, setIssueDate] = useState(null);
  const [issueNo, setIssueNo] = useState("");
  const [issueName, setIssueName] = useState("");
  const [issueHours, setIssueHours] = useState(0);
  const [issueType, setIssueType] = useState([]);
  const [issueCategory, setIssueCategory] = useState([]);
  const [selectedVartionIssue, setSelectedVartionIssue] = useState([]);
  const [issueRaisedBy, setIssueRaisedBy] = useState([]);
  const [issueErrorBy, setIssueErrorBy] = useState([]);
  const [issueAttendedBy, setIssueAttendedBy] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [isIssueEditMode, setIsIssueEditMode] = useState(false);
  const [issueToDelete, setIssueToDelete] = useState([]);
  const [deleteIssueDialogOpen, setDeleteIssueDialogOpen] = useState(false);
  const [isIssueCheckboxChecked, setIsIssueCheckboxChecked] = useState(false);
  const [bulkAction, setBulkAction] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [plannedHours, setPlannedHours] = useState({});
  const [companyDetails, setCompanyDetails] = useState({
    name: "",
    companyregno: "",
    contactno: "",
    email: "",
    website: "",
    logo: "",
    address: "",
    about: "",
    social: {
      facebook: "",
      twitter: "",
      linkedin: "",
    },
  });
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/api/company-settings");
        if (res.data) {
          setCompanyDetails((prev) => ({
            ...prev,
            ...res.data,
            social: {
              facebook: res.data?.social?.facebook || "",
              twitter: res.data?.social?.twitter || "",
              linkedin: res.data?.social?.linkedin || "",
            },
          }));
        }
      } catch (err) {
        console.error("Failed to fetch settings:", err);
      }
    };
    fetchSettings();
  }, []);
  //export variation
  const availableHeaders = [
    { key: "sno", label: "S.No" },
    { key: "date", label: "Date" },
    { key: "variationno", label: "Variation No" },
    { key: "name", label: "Variation Title" },
    { key: "description", label: "Description" },
    { key: "design", label: "DE PHrs" },
    { key: "designActual", label: "DE AHrs" },
    { key: "detailing", label: "DO PHrs" },
    { key: "detailingActual", label: "DO AHrs" },
    { key: "plannedhours", label: "Total PHrs" },
    { key: "actualhours", label: "Total AHrs" },
    { key: "invoice_status", label: "Claim Status" },
    { key: "variation_status", label: "Variation Status" },
    { key: "progress", label: "Progress" },
    { key: "created_by_name", label: "Created by" },
    { key: "approved_by_name", label: "Confirmed by" },
    { key: "invoice_no", label: "Invoice Number" },
    { key: "invoice_date", label: "Invoice Date" },
    { key: "exported_at", label: "Exported at" },
    { key: "exported_by", label: "Exported by" },
    { key: "Watermark", label: "Watermark" },
  ];

  // ✅ State to manage modal visibility and selected headers
  const [showModal, setShowModal] = useState(false);
  const [selectedHeaders, setSelectedHeaders] = useState(
    availableHeaders.map((header) => header.key)
  );

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // reset height
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px"; // adjust to content
    }
  }, [variationDescription]);

  // Convert "H:MM" or "HH:MM" to total minutes
  const parseTimeToMinutes = (timeString) => {
    if (!timeString || timeString === "0:00") return 0; // Default to 0 if empty
    const [hours, minutes] = timeString.split(":").map(Number);
    return (hours || 0) * 60 + (minutes || 0);
  };

  // Convert total minutes back to "H:MM" format
  const convertMinutesToTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}`; // Ensure "01" instead of "1"
  };

  // ✅ Toggle header selection
  const toggleHeaderSelection = (key) => {
    setSelectedHeaders(
      (prev) =>
        prev.includes(key)
          ? prev.filter((item) => item !== key) // Remove if already selected
          : [...prev, key] // Add if not selected
    );
  };

  // ✅ Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const handleDateChange = (tasktemplateId, taskId, dateType, date) => {
    const updateTaskDates = async () => {
      try {
        let start_date;
        let due_date;
        let parsedDate;
        if (typeof date === "string") {
          parsedDate = new Date(date);
        } else if (date instanceof Date) {
          parsedDate = date;
        }
        if (!isValid(parsedDate)) {
          console.error("Invalid date format", date);
          return;
        }
        const isoDate = parsedDate.toISOString().split("T")[0];
        if (dateType === "start_date") {
          start_date = isoDate;
        } else if (dateType === "due_date") {
          due_date = isoDate;
        }
        const payload = {};
        if (start_date) payload.start_date = start_date;
        if (due_date) payload.due_date = due_date;
        const response = await api.put(
          `/api/task/update-dates/${taskId}`,
          payload
        );
        fetchAllData(); // Refresh the data after update
      } catch (error) {
        console.error("Error updating task dates:", error);
      }
    };

    if (taskId && dateType) {
      updateTaskDates(); // Only update if taskId and dateType are present
    }
  };

  const handleCheckboxChange = (e, taskId) => {
    if (e.target.checked) {
      // Add the taskId to the selectedTTaskId array
      setSelectedTTaskId((prev) => [...prev, taskId]);
    } else {
      // Remove the taskId from the selectedTTaskId array
      setSelectedTTaskId((prev) => prev.filter((id) => id !== taskId));
    }
  };

  useEffect(() => {
    socket.on("user associated to the task", ({ userNames, taskId }) => {
      setTasksByPhase((prevState) => {
        return prevState.map((phase) => {
          return {
            ...phase,
            tasks: phase.tasks.map((task) => {
              if (task.id === Number(taskId)) {
                return {
                  ...task,
                  assigned_users: userNames.map((user) => ({
                    label: user.label,
                    value: user.value,
                  })),
                };
              }
              return task;
            }),
          };
        });
      });
    });

    socket.on(
      "task date updated",
      ({ taskId, updates, startDate, dueDate }) => {
        setTasksByPhase((prevPhases) =>
          prevPhases.map((phase) => ({
            ...phase,
            tasks: phase.tasks.map((task) =>
              task.id === Number(taskId)
                ? {
                    ...task,
                    ...(updates.includes("start_date") && {
                      start_date: startDate,
                    }),
                    ...(updates.includes("due_date") && { due_date: dueDate }),
                  }
                : task
            ),
          }))
        );
      }
    );
    socket.on("plannedhours updated", ({ id, plannedhours }) => {
      setTasksByPhase((prevPhases) => {
        return prevPhases.map((phase) => ({
          ...phase,
          tasks: phase.tasks.map((task) => {
            if (task.id === Number(id)) {
              return {
                ...task,
                planned_hours: plannedhours,
              };
            }
            return task;
          }),
        }));
      });
    });

    socket.on("task template added", ({ id, phase_id, name, tasks }) => {
      const newlyAddedTemplate = {
        id: id,
        phase_id: phase_id,
        name: name,
        tasks: tasks,
      };
      if (Number(phaseId) === Number(phase_id)) {
        // Update state only if the template with the same id doesn't already exist
        setTasksByPhase((prevTasks) => {
          // Check if the template with the same id already exists
          const templateExists = prevTasks.some(
            (template) => template.id === id
          );

          if (templateExists) {
            return prevTasks; // No update, just return the previous state
          }
          setProjectTemplates([...prevTasks, newlyAddedTemplate]);

          // If the template doesn't exist, add the newly added template
          const updatedTasks = [...prevTasks, newlyAddedTemplate];
          return updatedTasks;
        });
      }
    });

    socket.on("delete tasktemplate", ({ taskTemplateId }) => {
      setTasksByPhase((prevTasks) =>
        prevTasks.filter((task) => task.id !== Number(taskTemplateId))
      );
      setProjectTemplates((prevTasks) =>
        prevTasks.filter((task) => task.id !== Number(taskTemplateId))
      );
    });

    socket.on("variation added", (newlyAddedVariation) => {
      if (Number(phaseId) === Number(newlyAddedVariation.phase_id)) {
        setVariations((prev) => [...prev, newlyAddedVariation]);
      }
    });

    socket.on("variation updated", ({ id, updates }) => {
      setVariations((prevVariations) =>
        prevVariations.map((variation) =>
          variation.id === Number(id) ? { ...variation, ...updates } : variation
        )
      );
    });

    socket.on("variation edited", (updatedVariation, id) => {
      setVariations((prevVariations) =>
        prevVariations.map(
          (variation) =>
            variation.id === Number(id)
              ? { ...variation, ...updatedVariation } // Spread the updated values into the existing variation
              : variation // Keep the other variations unchanged
        )
      );
    });

    socket.on("variation deleted", (data) => {
      // Ensure that `variationIds` is an array
      const idsArray = Array.isArray(data.variationIds)
        ? data.variationIds
        : [data.variationIds];

      setVariations((prev) => {
        // Filter out the variations whose IDs are in the idsArray
        return prev.filter((variation) => !idsArray.includes(variation.id));
      });
    });

    socket.on("issue added", (newIssue) => {
      if (Number(phaseId) === Number(newIssue.phase_id)) {
        setIssues((prev) => [...prev, newIssue]);
      }
    });

    socket.on("issue deleted", (data) => {
      // Ensure that `variationIds` is an array
      const idsArray = Array.isArray(data.issueIds)
        ? data.issueIds
        : [data.issueIds];

      setIssues((prev) => {
        // Filter out the variations whose IDs are in the idsArray
        return prev.filter((issue) => !idsArray.includes(issue.id));
      });
    });

    return () => {
      socket.off("user associated to the task");
      socket.off("delete tasktemplate"); // Cleanup listener
      socket.off("task template added");
      socket.off("plannedhours updated");
      socket.off("task date updated");
      socket.off("variation added");
      socket.off("variation updated");
      socket.off("variation deleted");
      socket.off("variation edited");
      socket.off("issue added");
      socket.off("issue deleted");
    };
  }, []);

  const handleTaskUser = async (taskId, selectedOptions) => {
    const userIds = selectedOptions.map((option) => option.value);

    // Update the local state
    setTasksByPhase((prevState) => {
      return prevState.map((phase) => {
        return {
          ...phase,
          tasks: phase.tasks.map((task) => {
            if (task.id === taskId) {
              return {
                ...task,
                assigned_users: selectedOptions.map((user) => ({
                  label: user.label,
                  value: user.value,
                })),
              };
            }
            return task;
          }),
        };
      });
    });

    try {
      // Handle empty userIds case for the server
      const response = await api.put("/api/update-task-userid", {
        userIds, // Send an empty array when no users are selected
        taskId,
      });
      fetchAllData();
    } catch (error) {
      console.error(
        "Error updating users:",
        error.response?.data || error.message
      );
    }
  };
  const handleAddTemplate = () => {
    setVariationTemplate([...variationTemplate, { name: "", hours: "" }]);
  };

  const handleTemplateChange = (index, field, value) => {
    const updatedTemplates = [...variationTemplate];
    updatedTemplates[index][field] = value;
    setVariationTemplate(updatedTemplates);
  };

  const handleAddVariationHours = () => {
    for (let template of variationTemplate) {
      if (!template.name || !template.hours) {
        toast.error("Please select a template and enter hours before adding.", {
          position: "bottom-center",
          autoClose: 2000,
        });
        return; // Stop execution if validation fails
      }
    }
    setVariationHours([]);
    const totalMinutes = variationTemplate.reduce((sum, template) => {
      return sum + parseTimeToMinutes(template.hours);
    }, 0);
    setVariationHours(convertMinutesToTime(totalMinutes)); // Update variation hours
  };
  useEffect(() => {
    handleEditVariationHours(); // This will run when designHours changes
  }, [designHours, detailingHours]);

  const handleEditVariationHours = () => {
    const totalMinutes =
      parseTimeToMinutes(designHours) + parseTimeToMinutes(detailingHours);
    setVariationHours(convertMinutesToTime(totalMinutes)); // Update variation hours
  };
  const showTemplateHours = () => {
    if (designHours === "00:00") {
      setDesignHours("");
    }
    if (detailingHours === "00:00") {
      setDetailingHours("");
    }
  };

  function normalizePlannedHours(input) {
    // If input is a decimal (e.g., "1.5"), convert it to HH:MM format
    if (/^[0-9]+([.][0-9]+)?$/.test(input)) {
      const hours = Math.floor(parseFloat(input));
      const minutes = Math.round((parseFloat(input) - hours) * 60);
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }

    // If input is in HH:MM format, return it directly
    if (/^[0-9]+:[0-5][0-9]$/.test(input)) {
      return input;
    }

    // If input is a whole number, treat it as hours
    if (/^[0-9]+$/.test(input)) {
      return `${parseInt(input, 10)}:00`;
    }

    // For invalid formats, return an empty string
    return "";
  }

  // Handle planned hours change
  const handlePlannedHoursChange = (taskId, event, tasktemplateId) => {
    const value = normalizePlannedHours(event.target.value);
    setPlannedHours((prevState) => ({
      ...prevState,
      [taskId]: value,
    }));
  };

  const convertTimeToMinutes = (time) => {
    if (!time || time === "00:00") return 0; // Ensure empty or "00:00" is treated as 0
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes; // Convert time to total minutes
  };

  const convertMinutesToHHMM = (totalMinutes) => {
    const isNegative = totalMinutes < 0; // Check if the difference is negative
    const absoluteMinutes = Math.abs(totalMinutes); // Use absolute value for calculation
    const hours = Math.floor(absoluteMinutes / 60);
    const minutes = absoluteMinutes % 60;
    const formattedTime = `${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}`;
    return isNegative ? `-${formattedTime}` : formattedTime; // Add "-" if negative
  };

  const handleSavePlannedHours = (taskId) => {
    const hours = plannedHours[taskId];
    if (!hours || !/^([0-9]+:[0-5][0-9])$/.test(hours)) {
      toast.error("Please enter planned hours ", {
        position: "bottom-center",
        autoClose: 2000,
      });
      return;
    }
    savePlannedHoursToDatabase(taskId, phaseId, hours).catch((error) => {
      console.error("Error saving planned hours:", error);
      alert(error.message || "An error occurred while saving planned hours.");
    });
  };

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // fetch all details based on variation issue
  const fetchAllData = async () => {
    const fetchData = async (endpoint, setter) => {
      try {
        const response = await api.get(endpoint);
        setter(response.data);
      } catch (error) {
        setError(error);
      }
    };
    try {
      // Fetch all data concurrently
      await Promise.all([
        fetchData(`/api/phase/${phaseId}`, setPhase),
        fetchData(`/api/phase/${phaseId}/usertaskTemplates`, setTasksByPhase),
        fetchData(`/api/taskTemplates`, setTaskTemplates),
        fetchData(`api/phase/${phaseId}/taskTemplates`, setProjectTemplates),
        fetchData(`/api/users`, setUsers),
        fetchData(`/api/projects/${projectId}/users`, setProjectUsers),
        fetchData(`/api/phase/${phaseId}/variations`, (data) =>
          setVariations(Array.isArray(data) ? data : [])
        ),
        fetchData(`/api/phase/${phaseId}/issues`, (data) =>
          setIssues(Array.isArray(data) ? data : [])
        ),
        api.get(`/api/phase/${phaseId}/plannedHours`, (data) =>
          setPlannedHours(Array.isArray(data) ? data : [])
        ),
        fetchData(`/api/projects/${projectId}/customer`, setCustomer),
      ]);
    } finally {
      setLoading(false); // Ensure loading is set to false once all requests are done
    }
  };
  const savePlannedHoursToDatabase = async (taskId, phaseId, hours) => {
    try {
      // Validate inputs again before sending the request
      if (!taskId || !/^([0-9]+:[0-5][0-9])$/.test(hours)) {
        throw new Error(
          "Invalid taskId or hours. Please refresh the page and try again."
        );
      }

      // Send a PUT request to update planned hours
      const response = await api.put(
        `/api/phase_usertasks/${taskId}/plannedhours`,
        {
          plannedhours: hours, // Send HH:mm format
        }
      );
      const { id, plannedhours } = response.data;
      const formattedPlannedHours = plannedhours.includes(":")
        ? plannedhours
        : normalizePlannedHours(plannedhours);
      setTasksByPhase((prevPhases) => {
        return prevPhases.map((phase) => ({
          ...phase,
          tasks: phase.tasks.map((task) => {
            if (task.id === Number(id)) {
              return {
                ...task,
                planned_hours: formattedPlannedHours,
              };
            }
            return task;
          }),
        }));
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error in savePlannedHoursToDatabase:",
        error.message || error
      );
      throw error; // Re-throw the error to be caught in the calling function
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [phaseId]);

  //handleAddTask
  const handleAddTask = async () => {
    if (!taskTemplateId) {
      toast.error("Please select a task to add.", {
        position: "bottom-center",
        autoClose: 2000,
      });
      return;
    }

    try {
      const newTask = await addTaskToPhase(
        phaseId,
        Number(taskTemplateId),
        setError
      );
      if (newTask) {
        // Instead of removing the taskTemplateId, mark it as "used"
        setTaskTemplates((prevTemplates) =>
          prevTemplates.map((template) =>
            template.id === Number(taskTemplateId)
              ? { ...template, used: true } // Mark template as used instead of removing it
              : template
          )
        );
        // Clear the task template selection
        setTaskTemplateId("");
        // Clear any existing errors
        setError(null);
      }
    } catch (error) {
      console.error("Error adding task:", error);
    }
  };
  const handleDeleteTask = async () => {
    setIndividualDeleteTaskDialogOpen(true);
  };

  const handleDeleteClick = (taskTemplateId) => {
    setTaskToDelete(Number(taskTemplateId));
    setDeleteTaskDialogOpen(true);
  };

  const handleDeleteTaskTemplate = async () => {
    const taskTemplateId = Number(taskToDelete);

    if (!taskTemplateId) {
      console.error("No task template ID set for deletion.");
      alert("Please select a task template to delete.");
      return;
    }

    try {
      // Perform the deletion via API
      const response = await api.delete(
        `/api/phase/${phaseId}/usertaskTemplates/${taskTemplateId}`
      );

      if (response.status === 200) {
        // Update state to reflect the deletion
        setTasksByPhase((prevTasks) =>
          prevTasks.filter((task) => task.id !== taskTemplateId)
        );
        setTaskTemplates((prevTemplates) =>
          prevTemplates.map((template) =>
            template.id === taskTemplateId
              ? { ...template, used: false }
              : template
          )
        );
        setDeleteTaskDialogOpen(false);
        setIsCheckboxChecked(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage =
          error.response.data?.message || "An error occurred.";
        console.error("Deletion prevented:", errorMessage);
        toast.error(errorMessage, {
          position: "bottom-center",
          autoClose: 2000,
        });
      } else {
        console.error("Unexpected error during deletion:", error.message);
        alert("An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleDeleteAssociatedTask = async () => {
    if (selectedTTaskId.length > 0) {
      try {
        // Make the API request to delete the selected tasks
        const response = await api.delete("/api/deletetasks", {
          data: { taskIds: selectedTTaskId }, // Send taskIds as an array
        });
        setSelectedTTaskId([]);
        setIndividualDeleteTaskDialogOpen(false);
        setIsCheckboxCheckedForTask(false);
        setTasksByPhase((prevTasksByPhase) => {
          return prevTasksByPhase.map((phase) => {
            // Filter out tasks that have been deleted
            const updatedTasks = phase.tasks.filter(
              (task) => !selectedTTaskId.includes(task.id)
            );

            // Return the updated phase object with the remaining tasks
            return {
              ...phase,
              tasks: updatedTasks,
            };
          });
        });
      } catch (error) {
        console.error("Error details:", error);
        console.error("Error response:", error.response);
        // Optionally, show a user-friendly error message
        toast.error(
          error.response?.data?.message ||
            "An error occurred while deleting tasks.",
          {
            position: "bottom-center",
            autoClose: 2000,
          }
        );
      } finally {
        setSelectedTTaskId([]);
        setIndividualDeleteTaskDialogOpen(false);
        setIsCheckboxCheckedForTask(false);
      }
    } else {
      alert("Please select at least one task to delete.");
    }
  };
  const handleAddNewTask = async () => {
    try {
      // Check if the role name is not empty
      if (!newTask.name.trim()) {
        toast.error("Task name cannot be empty", {
          position: "bottom-center",
          autoClose: 2000,
        });
        return;
      }

      // Send POST request to create a new role
      const response = await api.post(
        `/api/addusertasks/${taskTemplateIdToAdd}/${phaseId}`,
        {
          name: newTask.name,
        }
      );

      // Handle the response
      if (response.status === 201) {
        const newTask = response.data; // Example: { id: 101, name: 'New Task', phase_id: '213' }

        // Update tasksByPhase state to include the new task in the correct phase
        setTasksByPhase((prevTasksByPhase) => {
          return prevTasksByPhase.map((phase) => {
            if (String(phase.id) === String(taskTemplateIdToAdd)) {
              // Add the new task to the "tasks" array of the matching phase
              return {
                ...phase,
                tasks: [...phase.tasks, newTask],
              };
            }
            return phase; // Return unchanged phase if not matched
          });
        });
        setAddTaskDial(false);
        setNewTask({ name: "" }); // Clear the input field
      }
    } catch (error) {
      console.error();
      toast.error("Failed to add new role:", error, {
        position: "bottom-center",
        autoClose: 2000,
      });
    }
  };

  const handleTabChange = (index) => {
    setTabIndex(index);
    localStorage.setItem("tabIndex", index);
  };

  const handleOpenVariationDialog = () => {
    setSelectedTaskId("");
    setVariationHours(0);
    setIsEditMode(false);
    setOpenVariationDialog(true);
  };
  const handleOpenEditVariationDialog = (variation) => {
    setIsEditMode(true);
    setVariationDate(variation.date);
    setSelectedVariation(variation);
    setVariationNo(variation.variationno);
    setVariationName(variation.name);
    setVariationDescription(variation.description);
    setSelectedTaskId(variation.taskId);
    setVariationHours(variation.plannedhours);
    setDetailingHours(variation.detailing);
    setDesignHours(variation.design);
    setOpenVariationDialog(true);
  };
  const handleAddVariation = async () => {
    if (!variationName) {
      toast.error("Please enter variation title ", {
        position: "bottom-center",
        autoClose: 2000,
      });
      return;
    }
    if (variationHours === "0:00" || variationHours === 0) {
      toast.error("Please enter planned hours ", {
        position: "bottom-center",
        autoClose: 2000,
      });
      return;
    }
    const newVariation = {
      variationDate,
      variationNo,
      variationName,
      variationDescription,
      taskId: selectedTaskId,
      variationHours,
      projectId: phase.project_id,
      created_by: userID,
      variationTemplate,
    };
    const addedVariation = await addVariationToPhase(
      phaseId,
      newVariation,
      setError
    );
    if (addedVariation) {
      fetchAllData();
      setOpenVariationDialog(false);
      setVariationDescription("");
      setVariationName("");
      setSelectedTaskId(""); // Reset selected task
      setVariationHours([]); // Reset variation hours
      setVariationTemplate([{ name: "", hours: "" }]);
      setVariationDate("");
      setShowCapsWarning(false);
      setShowDescriptionCapsWarning(false);
    }
  };

  const handleDeleteVariation = (e, variationId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // Add phaseId to the selectedPhaseId array
      setVariationToBulkUpdate((prev) => [...prev, variationId]);
    } else {
      // Remove phaseId from the selectedPhaseId array
      setVariationToBulkUpdate((prev) =>
        prev.filter((id) => id !== variationId)
      );
    }
  };

  //delete variation
  const handleDeleteConfirm = async () => {
    if (variationToBulkUpdate.length > 0) {
      try {
        // Send the array of variation IDs to the backend
        await api.delete(`/api/phase/${phaseId}/variations`, {
          data: { variationIds: variationToBulkUpdate },
        });

        // Update the state to remove the deleted variations
        setVariations((prevVariations) =>
          prevVariations.filter(
            (variation) => !variationToBulkUpdate.includes(variation.id)
          )
        );
      } catch (error) {
        console.error("Error deleting variations:", error);
      } finally {
        setBulkActionVariation(false);
        setDeleteDialogOpen(false);
        setIsCheckboxChecked(false);
        setVariationToBulkUpdate([]); // Reset the variations to delete
      }
    } else {
      alert("Please select at least one variation to delete.");
    }
  };

  function normalizePlannedHours(input) {
    // If input is a decimal (e.g., "1.5"), convert it to HH:MM format
    if (/^[0-9]+([.][0-9]+)?$/.test(input)) {
      const hours = Math.floor(parseFloat(input));
      const minutes = Math.round((parseFloat(input) - hours) * 60);
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }

    // If input is in HH:MM format, return it directly
    if (/^[0-9]+:[0-5][0-9]$/.test(input)) {
      return input;
    }

    // If input is a whole number, treat it as hours
    if (/^[0-9]+$/.test(input)) {
      return `${parseInt(input, 10)}:00`;
    }

    // For invalid formats, return an empty string
    return "";
  }

  // Handle save or add variation
  const handleSaveOrAddVariation = () => {
    if (isEditMode) {
      handleSaveVariation();
    } else {
      handleAddVariation();
    }
  };

  const handleSaveVariation = async () => {
    setLoading(true);
    try {
      const updatedVariation = {
        ...selectedVariation,
        date: variationDate,
        variationno: variationNo,
        name: variationName,
        description: variationDescription,
        plannedhours: convertMinutesToTime(
          parseTimeToMinutes(designHours) + parseTimeToMinutes(detailingHours)
        ),
        design: designHours,
        detailing: detailingHours,
        task_id: selectedTaskId,
      };
      if (updatedVariation.plannedhours === "0:00") {
        toast.error("Please enter planned hours ", {
          position: "bottom-center",
          autoClose: 2000,
        });
        return;
      }
      const response = await api.put(
        `/api/phase/${phaseId}/variation/${selectedVariation.id}`,
        updatedVariation
      );
      if (response.status === 200) {
        // Axios uses status codes for response validation
        fetchAllData();
        setVariations(
          variations.map((v) =>
            v.id === selectedVariation.id ? updatedVariation : v
          )
        );
        setOpenVariationDialog(false);
      } else {
        console.error("Error updating variation:", response.statusText);
      }
    } catch (error) {
      console.error("Error saving variation:", error);
    } finally {
      setLoading(false);
      setShowCapsWarning(false);
      setShowDescriptionCapsWarning(false);
    }
  };

  const getColorForStatus = (status) => {
    switch (status) {
      case "Accepted":
        return "#ADD8E6"; // Light Blue
      case "Approved":
        return "#a3d6a7"; // Light Green
      case "Confirmed":
        return "#76D7C4"; // Teal
      case "Rejected":
        return "#FA2929"; // Red
      case "Waiting":
        return "orange"; // Orange
      case "Hold":
        return "#c9a0dc"; // Wisteria
      case "Verified":
        return "#344feb"; // Wisteria
      default:
        return "black";
    }
  };

  const updateClaimStatus = async (
    variationId,
    newValue,
    fieldType,
    userId
  ) => {
    try {
      setLoading(true);
      if (fieldType === "status" && newValue === "Unclaimed") {
        const confirmUnclaim = window.confirm(
          "Are you sure you want to change the status to Unclaimed?"
        );
        if (!confirmUnclaim) {
          return;
        }
      }

      const validFieldTypes = [
        "status",
        "date",
        "number",
        "variation_status",
        "progress",
      ];
      if (!validFieldTypes.includes(fieldType)) {
        console.error("Invalid field type:", fieldType);
        return;
      }
      const frontendURL = window.location.origin;

      let requestData = {};
      let variationNo;

      if (fieldType === "status") {
        requestData = { status: newValue };
      } else if (fieldType === "date") {
        requestData = { date: newValue ? newValue.toISOString() : null };
      } else if (fieldType === "number") {
        requestData = { invoice_no: newValue };
      } else if (fieldType === "variation_status") {
        if (newValue === "Accepted") {
          const approvedCount = variations.filter((variation) =>
            ["Approved", "Confirmed", "Accepted"].includes(
              variation.variation_status
            )
          ).length;

          const suggestedVariationNo = `VO-${String(approvedCount + 1).padStart(
            2,
            "0"
          )}`;

          variationNo = suggestedVariationNo;
        }

        requestData = {
          variation_status: newValue,
          approved_by: userId,
          variationno: variationNo,
        };
      } else if (fieldType === "progress") {
        requestData = { progress: newValue };
      }

      const response = await api.put(`/api/phase/${variationId}/approval`, {
        requestData,
        frontendURL,
      });

      if (response.status === 200) {
        const updatedFields = {};
        if (requestData.status)
          updatedFields.invoice_status = requestData.status;
        if (requestData.date) updatedFields.invoice_date = requestData.date;
        if (requestData.invoice_no)
          updatedFields.invoice_no = requestData.invoice_no;
        if (requestData.variation_status)
          updatedFields.variation_status = requestData.variation_status;
        if (requestData.progress) updatedFields.progress = requestData.progress;

        setVariations((prev) =>
          prev.map((v) =>
            v.id === variationId ? { ...v, ...updatedFields } : v
          )
        );
      } else {
        console.error(
          "Failed to update variation:",
          response.statusText || "No status text"
        );
      }
    } catch (error) {
      console.error("Error updating variation:", error);
    } finally {
      setLoading(false);
    }
  };

  const getColorValue = (value) => {
    let color;
    if (value === "Claimed") {
      color = "#a3d6a7";
    } else if (value === "Unclaimed") {
      color = "#e4d1b9";
    } else if (value === "Ignored") {
      color = "orange";
    } else if (value === "Expired") {
      color = "red";
    }

    return color;
  };

  const updateBulkVariationClaimStatus = async (variationIds, newStatus) => {
    try {
      // If the new status is "Unclaimed", show confirmation
      if (newStatus === "Unclaimed") {
        const confirmUnclaim = window.confirm(
          "Are you sure you want to change the status of selected phases to Unclaimed?"
        );

        // If user clicks "No", stop the function
        if (!confirmUnclaim) {
          return; // Exit without making changes
        }
      }

      // Send the bulk update request to the backend
      const response = await api.put("/api/variation/bulk-approval", {
        variationIds,
        status: newStatus,
      });

      if (response.status === 200) {
        // Show success message
        setBulkActionVariation(false);
        setIsCheckboxChecked(false);
        setVariationToBulkUpdate([]);
        setClaimStatusVariation(false);
        // Update the variations state directly based on the bulk update
        setVariations((prev) =>
          prev.map((v) =>
            variationIds.includes(v.id)
              ? { ...v, invoice_status: newStatus } // Update the status of the modified variations
              : v
          )
        );
      } else {
      }
    } catch (error) {
      console.error("Failed to update bulk statuses", error);
      toast.error(error.response?.data?.message, {
        position: "bottom-center",
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        variationRef.current &&
        !variationRef.current.contains(event.target)
      ) {
        setBulkActionVariation(false);
      }
      if (issueRef.current && !issueRef.current.contains(event.target)) {
        setBulkAction(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
  }, []);

  //issues
  const addIssueToPhase = async (phaseId, issueData, setError) => {
    try {
      const response = await api.post(
        `/api/phase/${phaseId}/addIssue`,
        issueData
      );
      fetchAllData();
      setIssueAttendedBy([]);
      setIssueErrorBy([]);
      setIssueRaisedBy([]);
      setIssueType([]);
      setIssueName([]);
      setIssueCategory([]);
      setSelectedVartionIssue([]);
      setIssueDate(null);
      return response.data;
    } catch (error) {
      setError(error);
    }
  };

  const handleAddIssue = async () => {
    const newIssue = {
      issueDate,
      issueNo,
      issueName,
      issueCategory,
      selectedVartionIssue,
      issueType,
      issueRaisedBy,
      issueErrorBy,
      issueAttendedBy,
      projectId: phase.project_id, // Assuming phase has a project_id field
    };
    const addedIssue = await addIssueToPhase(phaseId, newIssue, setError);
    if (addedIssue) {
      setIssues((prev) => [...prev, addedIssue]);
      setOpenIssueDialog(false);
      setSelectedTaskId(""); // Reset selected task
      setIssueHours(0); // Reset issue hours
    }
  };

  const handleOpenIssueDialog = () => {
    const suggestedIssueNo = `IS-${String((issues?.length || 0) + 1).padStart(
      2,
      "0"
    )}`;
    setIssueNo(suggestedIssueNo);
    setIssueName(`${phase.phaseno}-${suggestedIssueNo}`);
    setSelectedTaskId("");
    setIssueHours(0);
    setIsIssueEditMode(false);
    setOpenIssueDialog(true);
  };

  const handleOpenEditIssueDialog = (issue) => {
    setIssueDate(issue.date);
    setIsIssueEditMode(true);
    setSelectedIssue(issue);
    setIssueNo(issue.issue_number);
    setIssueName(issue.name);
    setSelectedTaskId(issue.taskId);
    setIssueHours(issue.issuehours);
    setOpenIssueDialog(true);
    setIssueErrorBy(issue.errorby_ids);
    setIssueCategory(issue.category);
    setSelectedVartionIssue(issue.variation_id);
    if (issue.type === "internal") {
      setIssueRaisedBy(issue.raisedby_user);
    }
    if (issue.type === "external") {
      setIssueRaisedBy(issue.raisedby_client);
    }
    setIssueType(issue.type);
    setIssueAttendedBy(issue.attendedby_ids);
  };

  const handleSaveIssue = async () => {
    try {
      const updatedIssue = {
        ...selectedIssue,
        date: issueDate,
        name: issueName,
        issuehours: issueHours,
        category: issueCategory,
        variation_id: selectedVartionIssue ? selectedVartionIssue : null,
        task_id: selectedTaskId,
        type: issueType,
        ...(issueType === "internal"
          ? { raisedby_user: issueRaisedBy }
          : { raisedby_client: issueRaisedBy }),
        errorby: issueErrorBy,
        attendedby: issueAttendedBy,
      };

      const response = await api.put(
        `/api/phase/${phaseId}/issue/${selectedIssue.id}`,
        updatedIssue
      );

      if (response.status === 200) {
        // Axios does not throw on non-2xx responses, check status manually
        setIssues(
          issues.map((issue) =>
            issue.id === selectedIssue.id ? updatedIssue : issue
          )
        );
        fetchAllData();
        setOpenIssueDialog(false);
        setIssueAttendedBy([]);
        setIssueErrorBy([]);
        setIssueRaisedBy([]);
        setIssueType([]);
        setIssueName([]);
        setIssueDate(null);
        // setIssueNo([]);
      } else {
        console.error("Error updating issue:", response.statusText);
      }
    } catch (error) {
      console.error("Error saving issue:", error);
    } finally {
      setIssueAttendedBy([]);
      setIssueErrorBy([]);
      setIssueRaisedBy([]);
      setIssueType([]);
      setIssueName([]);
    }
  };

  const handleDeleteIssue = (e, issueId) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // Add issueId to the state array
      setIssueToDelete((prev) => [...prev, issueId]);
    } else {
      // Remove issueId from the state array if unchecked
      setIssueToDelete((prev) => prev.filter((id) => id !== issueId));
    }
  };

  // Delete issue
  const handleDeleteIssueConfirm = async () => {
    if (issueToDelete.length > 0) {
      try {
        // Send the array of issue IDs to the backend for deletion
        await api.delete(`/api/phase/${phaseId}/issues`, {
          data: { issueIds: issueToDelete },
        });

        // Update the state to remove the deleted issues
        setIssues((prevIssues) =>
          prevIssues.filter((issue) => !issueToDelete.includes(issue.id))
        );
      } catch (error) {
        console.error("Error deleting issues:", error);
      } finally {
        setDeleteIssueDialogOpen(false);
        setIsIssueCheckboxChecked(false); // Reset the checkbox state
        setIssueToDelete([]); // Clear the selected issues after deletion
      }
    } else {
      alert("Please select at least one issue to delete.");
    }
  };

  if (loading)
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );
  if (error)
    return (
      <p color="error" className="error-message">
        Error: {error.message}
      </p>
    );
  if (!phase) return <p>No phase found</p>;

  const totalVariationHours = variations.reduce((total, variation) => {
    // Convert plannedhours (HH:mm:ss) into total minutes
    const timeParts = (variation.plannedhours || "00:00:00").split(":");
    const hoursInMinutes = parseInt(timeParts[0], 10) * 60; // Convert hours to minutes
    const minutes = parseInt(timeParts[1], 10); // Minutes

    const totalMinutes = hoursInMinutes + minutes;

    // Add the total minutes to the running total
    return total + totalMinutes;
  }, 0);

  // Convert total minutes back to HH:mm format
  const hours = Math.floor(totalVariationHours / 60);
  const minutes = totalVariationHours % 60;

  // Format the total time as HH:mm
  const formattedTotalVariationHours = `${hours
    .toString()
    .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

  const allUnclaimed = variations.every(
    (variation) => variation.invoice_status !== "Claimed"
  );

  const exportToExcelVariation = () => {
    const exportedDate = new Date();
    const formattedExportedDate = `${String(exportedDate.getDate()).padStart(
      2,
      "0"
    )}-${String(exportedDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${exportedDate.getFullYear()} ${String(exportedDate.getHours()).padStart(
      2,
      "0"
    )}:${String(exportedDate.getMinutes()).padStart(2, "0")}:${String(
      exportedDate.getSeconds()
    ).padStart(2, "0")}`;

    const variationsToExport =
      variationToBulkUpdate.length > 0
        ? variations.filter((v) => variationToBulkUpdate.includes(v.id))
        : variations;
    const exportedByText = selectedHeaders.includes("exported_by")
      ? `${userDetails.name} `
      : "";
    const exportedAt = selectedHeaders.includes("exported_at")
      ? `${formattedExportedDate}`
      : "";
    const headers = availableHeaders
      .filter((header) => selectedHeaders.includes(header.key))
      .map((header) => header.label);
    const exportMetaInfo = [
      // First row: Customer and Exported info
      [
        "Customer",
        variationsToExport[0]?.customer_name || "",
        ...Array(headers.length - 3).fill(""), // empty padding cells
        exportedByText, // align to the last column
      ],
      [
        "Project",
        `${phase.projectno} - ${phase.project_name}`,
        ...Array(headers.length - 3).fill(""), // empty padding cells
        exportedAt,
      ],
      ["Phase", `${phase.phaseno} - ${phase.title}`],
      ["Subject", "Variation Details"],
    ];
    const summableKeys = [
      "design",
      "designActual",
      "detailing",
      "detailingActual",
      "plannedhours",
      "actualhours",
    ];

    const columnsToSum = {};
    availableHeaders.forEach((header, i) => {
      if (
        summableKeys.includes(header.key) &&
        selectedHeaders.includes(header.key)
      ) {
        columnsToSum[header.key] = headers.indexOf(header.label);
      }
    });

    const body = variationsToExport
      .slice()
      .sort((a, b) => {
        const numA = a.variationno
          ? parseInt(a.variationno.replace("VO-", ""), 10)
          : Infinity;
        const numB = b.variationno
          ? parseInt(b.variationno.replace("VO-", ""), 10)
          : Infinity;
        return numA - numB;
      })
      .map((variation, index) => {
        return availableHeaders
          .filter((header) => selectedHeaders.includes(header.key))
          .map((header) => {
            let value = variation[header.key] || "";
            if (header.key === "date")
              value = value ? format(value, "dd-MM-yyyy") : "";
            if (
              [
                "plannedhours",
                "actualhours",
                "design",
                "designActual",
                "detailing",
                "detailingActual",
              ].includes(header.key)
            ) {
              value = value === "00:00" ? "00:00" : value;
            }
            if (header.key === "invoice_date")
              value = value ? format(value, "dd-MM-yyyy") : "";
            return header.key === "sno" ? index + 1 : value;
          });
      });

    const sumTimeFields = (rows, indexMap) => {
      const total = Object.fromEntries(
        Object.entries(indexMap).map(([key]) => [key, 0])
      );

      rows.forEach((row) => {
        Object.entries(indexMap).forEach(([key, colIndex]) => {
          const timeStr = row[colIndex];
          if (typeof timeStr === "string" && timeStr.includes(":")) {
            const [hours, minutes] = timeStr.split(":").map(Number);
            total[key] += hours * 60 + minutes;
          }
        });
      });

      return Object.entries(total).reduce((acc, [key, mins]) => {
        const hh = String(Math.floor(mins / 60)).padStart(2, "0");
        const mm = String(mins % 60).padStart(2, "0");
        acc[key] = `${hh}:${mm}`;
        return acc;
      }, {});
    };

    const totals = sumTimeFields(body, columnsToSum);
    const totalRow = headers.map((_, i) => {
      const key = Object.keys(columnsToSum).find((k) => columnsToSum[k] === i);
      return key ? totals[key] : i === 0 ? "Total" : "";
    });

    // ✅ Move this block here BEFORE it's used
    const footerDescriptions = {
      "DE PHrs": "Design planned hours",
      "DE AHrs": "Design actual hours",
      "DO PHrs": "Detailing planned hours",
      "DO AHrs": "Detailing actual hours",
      "Total PHrs": "Total planned hours",
      "Total AHrs": "Total actual hours",
    };

    const footerTextLines = availableHeaders
      .filter((header) => selectedHeaders.includes(header.key))
      .map((header) => {
        const label = header.label;
        const description = footerDescriptions[label];
        return description ? `${label} - ${description}` : null;
      })
      .filter(Boolean);

    const worksheetData = [
      ...exportMetaInfo,
      [],
      headers,
      ...body,
      totalRow,
      [],
      footerTextLines, // ✅ no error now
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Variations");

    const fileName = `${phase.title.replace(
      /[^a-zA-Z0-9]/g,
      "_"
    )}_VO_${formattedExportedDate}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };
  const toBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const exportToPDFVariation = async () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const logoBase64 = await toBase64(
      `${window.location.origin}/AppLayout/mses.png`
    );

    const startY = 10;
    const infoBoxHeight = 25;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 2;
    const contentBoxHeight = infoBoxHeight + 180;

    const variationsToExport =
      variationToBulkUpdate.length > 0
        ? variations.filter((v) => variationToBulkUpdate.includes(v.id))
        : variations;

    const filteredSelectedHeaders = selectedHeaders.filter(
      (key) =>
        key !== "exported_by" && key !== "exported_at" && key !== "Watermark"
    );

    const summableKeys = [
      "design",
      "designActual",
      "detailing",
      "detailingActual",
      "plannedhours",
      "actualhours",
    ];

    const finalHeaders = availableHeaders.filter((header) =>
      filteredSelectedHeaders.includes(header.key)
    );

    const columnsToSum = {};
    finalHeaders.forEach((header, i) => {
      if (summableKeys.includes(header.key)) {
        columnsToSum[header.key] = i;
      }
    });

    const body = variationsToExport
      .slice()
      .sort((a, b) => {
        const numA = a.variationno
          ? parseInt(a.variationno.replace("VO-", ""), 10)
          : Infinity;
        const numB = b.variationno
          ? parseInt(b.variationno.replace("VO-", ""), 10)
          : Infinity;
        return numA - numB;
      })
      .map((variation, index) => {
        return finalHeaders.map((header) => {
          let value = variation[header.key] || "";
          if (header.key === "date") {
            value = value ? format(value, "dd-MM-yyyy") : "";
          }
          if (
            [
              "plannedhours",
              "actualhours",
              "design",
              "designActual",
              "detailing",
              "detailingActual",
            ].includes(header.key)
          ) {
            value = value === "00:00" || value === "" ? "00:00" : value;
          }
          if (header.key === "invoice_date") {
            value = formatDate(value);
          }
          return header.key === "sno" ? index + 1 : value;
        });
      });

    const sumTimeFields = (rows, indexMap) => {
      const total = Object.fromEntries(
        Object.keys(indexMap).map((key) => [key, 0])
      );

      rows.forEach((row) => {
        Object.entries(indexMap).forEach(([key, colIndex]) => {
          const timeStr = row[colIndex];
          if (typeof timeStr === "string" && /^\d{1,2}:\d{2}$/.test(timeStr)) {
            const [hours, minutes] = timeStr.split(":").map(Number);
            total[key] += hours * 60 + minutes;
          }
        });
      });

      return Object.fromEntries(
        Object.entries(total).map(([key, mins]) => {
          const hh = String(Math.floor(mins / 60)).padStart(2, "0");
          const mm = String(mins % 60).padStart(2, "0");
          return [key, `${hh}:${mm}`];
        })
      );
    };

    const totals = sumTimeFields(body, columnsToSum);
    const totalRow = finalHeaders.map((header, i) =>
      totals.hasOwnProperty(header.key)
        ? totals[header.key]
        : i === 0
        ? "Total"
        : ""
    );
    body.push(totalRow);

    const footerDescriptions = {
      "DE PHrs": "Design planned hours",
      "DE AHrs": "Design actual hours",
      "DO PHrs": "Detailing planned hours",
      "DO AHrs": "Detailing actual hours",
      "Total PHrs": "Total planned hours",
      "Total AHrs": "Total actual hours",
    };

    const footerTextLines = finalHeaders
      .map((header) => {
        const label = header.label;
        const description = footerDescriptions[label];
        return description ? `${label} - ${description}` : null;
      })
      .filter(Boolean);

    autoTable(doc, {
      startY: startY + infoBoxHeight,
      head: [finalHeaders.map((h) => h.label)],
      body: body,
      columnStyles: {
        0: { cellWidth: "wrap", overflow: "linebreak" },
        1: { cellWidth: "auto", overflow: "hidden" },
        2: { cellWidth: 25, overflow: "ellipsize" },
      },
      styles: { fontSize: 10 },
      headStyles: { fillColor: [22, 160, 133] },
      margin: { left: margin + 5, right: margin + 5 },
      didDrawPage: function (data) {
        const pageNumber = doc.internal.getNumberOfPages();

        // Always draw the outer content box border
        doc.setDrawColor("#48494d");
        doc.setLineWidth(0.3);
        doc.rect(margin, margin, pageWidth - 2 * margin, contentBoxHeight);

        // Only draw the info box and header on the first page
        if (pageNumber === 1) {
          doc.setDrawColor("#ddd");
          doc.setLineWidth(0.3);
          doc.rect(7, startY - 5, pageWidth - 14, 27);

          doc.setFontSize(10);
          doc.setFont(undefined, "bold");
          doc.text(`Customer : ${[variations[0].customer_name]}`, 8, startY);
          doc.text(
            `Project : ${phase.projectno}-${phase.project_name}`,
            8,
            startY + 6
          );
          doc.text(`Phase : ${phase.phaseno}-${phase.title}`, 8, startY + 12);
          doc.text("Subject : Variation details", 8, startY + 18);

          // ✅ Add logo and address
          try {
            doc.addImage(logoBase64, "PNG", pageWidth - 50, startY - 3, 38, 10);
          } catch (err) {
            console.error("Failed to add logo:", err);
          }

          if (companyDetails?.address) {
            const splitAddress = doc.splitTextToSize(
              companyDetails.address,
              50
            );
            doc.setFontSize(8);
            doc.setFont(undefined, "normal");
            doc.text(splitAddress, pageWidth - 50, startY + 12);
          }

          // ✅ Exported info below logo/address
          const exportedDate = new Date();
          const formattedExportedDate = `${String(
            exportedDate.getDate()
          ).padStart(2, "0")}-${String(exportedDate.getMonth() + 1).padStart(
            2,
            "0"
          )}-${exportedDate.getFullYear()} ${String(
            exportedDate.getHours()
          ).padStart(2, "0")}:${String(exportedDate.getMinutes()).padStart(
            2,
            "0"
          )}`;
          const textWidth = doc.getTextWidth(`${formattedExportedDate}`);
          const xPosition = pageWidth - textWidth - 8;

          doc.setFont(undefined, "normal");
          doc.setFontSize(8);
          // if (selectedHeaders.includes("exported_at")) {
          //   doc.text(
          //     `${formattedExportedDate}`,
          //     xPosition,
          //     selectedHeaders.includes("exported_by") ? startY + 6 : startY
          //   );
          // }
          // if (selectedHeaders.includes("exported_by")) {
          //   doc.text(`${userDetails.name}`, xPosition, startY);
          // }
        }

        // Footer (drawn on all pages)
        doc.setFont(undefined, "normal");
        doc.setFontSize(7);

        const footerY = pageHeight - 10;
        let footerX = margin + 5;

        // Draw footer description lines (the existing dynamic footer items)
        footerTextLines.forEach((line) => {
          const textWidth = doc.getTextWidth(line) + 10;
          if (footerX + textWidth < pageWidth - margin) {
            doc.text(line, footerX, footerY);
            footerX += textWidth;
          }
        });

        // Base system note
        const baseFooterText = "This is system generated pdf";
        const baseFooterY = footerY + 5;

        // Draw the main footer note centered
        doc.text(baseFooterText, pageWidth / 2, baseFooterY, {
          align: "center",
        });

        // --- Added section: exported info near footer ---

        // Left side: Exported by
        if (selectedHeaders.includes("exported_by")) {
          doc.text(`Exported by: ${userDetails.name}`, margin + 5, baseFooterY);
        }
        const exportedDate = new Date();
        const formattedExportedDate = `${String(
          exportedDate.getDate()
        ).padStart(2, "0")}-${String(exportedDate.getMonth() + 1).padStart(
          2,
          "0"
        )}-${exportedDate.getFullYear()} ${String(
          exportedDate.getHours()
        ).padStart(2, "0")}:${String(exportedDate.getMinutes()).padStart(
          2,
          "0"
        )}`;
        // Right side: Exported at
        if (selectedHeaders.includes("exported_at")) {
          const exportedText = `Exported at: ${formattedExportedDate}`;
          const textWidth = doc.getTextWidth(exportedText);
          const rightX = pageWidth - textWidth - margin - 5;
          doc.text(exportedText, rightX, baseFooterY);
        }

        // Watermark (optional on all pages)
        if (selectedHeaders.includes("Watermark")) {
          doc.setFontSize(50);
          doc.setFont(undefined, "bold");
          doc.setTextColor(150, 150, 150);
          const centerX = pageWidth / 2;
          const centerY = pageHeight / 2;
          doc.saveGraphicsState();
          try {
            doc.setGState(new doc.GState({ opacity: 0.1 }));
          } catch (e) {}
          doc.text("MSES", centerX, centerY, {
            align: "center",
            angle: 45,
          });
          doc.restoreGraphicsState();
        }
      },
    });

    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${today.getFullYear()}`;
    const fileName = `${phase.title.replace(
      /[^a-zA-Z0-9]/g,
      "_"
    )}_VO_${formattedDate}.pdf`;
    doc.save(fileName);
  };

  const exportToExcel = () => {
    // Create a new worksheet with custom headers including the phase title
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(
        isNavBarOpen ? ".variation-table" : ".variation-table-close"
      )
    );

    // Set phase.title as the first row of the Excel file
    const phaseHeader = [
      { v: `Phase Title: ${phase.title}`, s: { font: { bold: true, sz: 14 } } },
    ];

    // Convert the worksheet data into an array of objects (JSON)
    const wsData = XLSX.utils.sheet_to_json(ws, { header: 1 });

    // Insert the 'S.No' column at the start of each row in wsData
    const dataWithSerialNo = wsData.map((row, index) => {
      if (index === 0) {
        // Add 'S.No' header for the first row
        return ["S.No", ...row];
      } else {
        // Add serial number for subsequent rows
        return [index, ...row];
      }
    });

    // Combine the phaseHeader with the dataWithSerialNo (Phase Title + Data)
    const fullData = [phaseHeader, ...dataWithSerialNo];

    // Create a new worksheet with the updated data
    const newWs = XLSX.utils.aoa_to_sheet(fullData);

    // Create the workbook and set the sheet name
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, newWs, "Issues");

    // Use the phase.title for the Excel file name
    const fileName = `${phase.title.replace(/[^a-zA-Z0-9]/g, "_")}_issues.xlsx`; // Replace spaces or special chars

    // Download the Excel file with the name based on phase.title
    XLSX.writeFile(wb, fileName);
  };

  const handleVariationNameChange = (e) => {
    const value = e.target.value;
    setVariationName(value);

    // Check if entire input is in uppercase and long enough
    const isAllCaps = value.length > 4 && value === value.toUpperCase();

    // Show warning if the whole input is capitalized
    setShowCapsWarning(isAllCaps);
  };

  const handleVariationDescriptionChange = (e) => {
    const value = e.target.value;
    setVariationDescription(value);

    // Check if entire input is in uppercase and long enough
    const isAllCaps = value.length > 4 && value === value.toUpperCase();

    // Show warning if the whole input is capitalized
    setShowDescriptionCapsWarning(isAllCaps);
  };

  return (
    <>
      <Helmet>
        <title>Msuite - Projects</title>
      </Helmet>
      {!dialBoxopen && (
        <div className={isNavBarOpen ? "phase-details" : "phase-details-close"}>
          <div
            className={
              isNavBarOpen
                ? "phase-gen-var-issue-con"
                : "phase-gen-var-issue-con-close"
            }
          >
            <div style={{ display: "flex" }}>
              <h3 className="phase-title">Phase No : {phase.phaseno}</h3>
              <h3 className="phase-title">Phase Title : {phase.title}</h3>
            </div>
            <div className="tabs">
              <button
                onClick={() => handleTabChange(0)}
                className={`tab-button ${tabIndex === 0 ? "active" : ""}`}
              >
                General
              </button>
              <button
                onClick={() => handleTabChange(1)}
                className={`tab-button ${tabIndex === 1 ? "active" : ""}`}
              >
                Variations
              </button>
              <button
                onClick={() => handleTabChange(2)}
                className={`tab-button ${tabIndex === 2 ? "active" : ""}`}
              >
                Issues
              </button>
            </div>

            {tabIndex === 0 && (
              <div className="phase-taks-template-table">
                {hasPermission("projects", "update") && (
                  <>
                    {taskTemplates.some(
                      (template) =>
                        !tasksByPhase.some((task) => task.id === template.id)
                    ) ? (
                      <>
                        <select
                          className="add-task-template"
                          label="Task Template"
                          value={taskTemplateId}
                          style={{
                            backgroundColor: "white",
                            padding: "4px",
                            borderRadius: "3px",
                            fontFamily: '"Lato", sans-serif',
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          onChange={(e) => setTaskTemplateId(e.target.value)}
                          displayEmpty
                          fullWidth
                        >
                          <option value="" disabled>
                            Select a task template
                          </option>
                          {taskTemplates
                            .filter(
                              (template) =>
                                !tasksByPhase.some(
                                  (task) => task.id === template.id
                                )
                            ) // Filtering unassociated templates
                            .map((template) => (
                              <option key={template.id} value={template.id}>
                                {template.name}
                              </option>
                            ))}
                        </select>
                        <button
                          onClick={handleAddTask}
                          variant="contained"
                          color="primary"
                          fullWidth
                          style={{
                            marginTop: "16px",
                            textWrap: "nowrap",
                            width: "auto",
                            fontFamily: '"Lato", sans-serif',
                            fontSize: "13px",
                            cursor: "pointer",
                          }}
                          className="add-btn"
                          title="Add Task"
                        >
                          Add Task Template
                        </button>
                      </>
                    ) : (
                      <p>All tasks are selected</p>
                    )}
                  </>
                )}
                {/* Display associated tasks */}
                <div style={{ display: "flex" }}>
                  <h3 className="task-name">Associated Tasks:</h3>
                  {hasPermission("projects", "delete") &&
                    selectedTTaskId.length !== 0 && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent toggle from firing
                          handleDeleteTask();
                        }}
                        className={
                          isNavBarOpen
                            ? "add-user-task-btn"
                            : "add-user-task-btn-close"
                        }
                        title="Delete Task"
                      >
                        Delete Task
                      </button>
                    )}
                </div>

                <div className="phase-associated-tasks">
                  {tasksByPhase.length > 0 ? (
                    tasksByPhase.map((taskTemplate, index) => {
                      // Calculate total planned hours, actual hours, and difference
                      const totalPlannedHours = taskTemplate.tasks?.reduce(
                        (sum, task) =>
                          sum + (convertTimeToMinutes(task.planned_hours) || 0),
                        0
                      );
                      const totalActualHours = taskTemplate.tasks?.reduce(
                        (sum, task) =>
                          sum + (convertTimeToMinutes(task.actualhours) || 0),
                        0
                      );
                      const totalDifference =
                        totalPlannedHours - totalActualHours;

                      return (
                        <div
                          key={taskTemplate.id}
                          className={
                            isNavBarOpen ? "accordion" : "accordion-close"
                          }
                        >
                          <div
                            className="accordion-summary"
                            style={{
                              display: "flex",
                              fontWeight: "normal",
                              alignItems: "center",
                            }}
                            onClick={() => handleToggle(index)}
                          >
                            <h6 className="phase-table-title">
                              {taskTemplate.name} :
                              <span
                                style={{
                                  marginLeft: "15px",
                                  fontSize: "14px",
                                }}
                              >
                                Planned:{" "}
                                {convertMinutesToHHMM(totalPlannedHours)} |
                                Actual: {convertMinutesToHHMM(totalActualHours)}{" "}
                                | Difference:
                                <span
                                  style={{
                                    color:
                                      totalDifference >= 0 ? "green" : "red",
                                  }}
                                >
                                  {convertMinutesToHHMM(totalDifference)}
                                </span>
                              </span>
                            </h6>

                            {hasPermission("projects", "delete") && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent toggle from firing
                                  handleDeleteClick(taskTemplate.id);
                                }}
                                style={{
                                  marginLeft: "auto",
                                  marginRight: "10px",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                title="Delete Task Template"
                              >
                                <DeleteIcon style={{ color: "red" }} />
                              </button>
                            )}
                          </div>
                          <div className="accordion-details">
                            <table className="accordion-table phase-general-table">
                              <thead>
                                <tr>
                                  {hasPermission("projects", "delete") && (
                                    <th style={{ width: "2px" }}>
                                      <FaChevronDown />
                                    </th>
                                  )}
                                  <th className="task-name">Task Name</th>
                                  <th className="task-user-name">
                                    Assigned to
                                  </th>
                                  <th className="general-associated-task-table">
                                    Start Date
                                  </th>
                                  <th className="general-associated-task-table">
                                    Due Date
                                  </th>

                                  <th className="general-associated-task-table">
                                    Total PHrs
                                  </th>

                                  <th className="actual-hours">Total AHrs</th>

                                  <th className="actual-hours">Difference</th>

                                  <th
                                    style={{
                                      width: !hasPermission("phases", "update")
                                        ? "1300px"
                                        : "300px",
                                    }}
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                {taskTemplate.tasks &&
                                  Array.isArray(taskTemplate.tasks) &&
                                  taskTemplate.tasks
                                    .sort((a, b) => {
                                      if (!a.name || !b.name) return 0; // Handle missing names

                                      // Extract numbers from names
                                      const matchA = a.name.match(/\d+/);
                                      const matchB = b.name.match(/\d+/);

                                      // Assign default value if no number is found
                                      const numA = matchA
                                        ? parseInt(matchA[0], 10)
                                        : Number.MAX_VALUE;
                                      const numB = matchB
                                        ? parseInt(matchB[0], 10)
                                        : Number.MAX_VALUE;

                                      return numA - numB;
                                    })

                                    .map((task) => (
                                      <tr key={task.id}>
                                        {hasPermission(
                                          "projects",
                                          "delete"
                                        ) && (
                                          <td style={{ textAlign: "center" }}>
                                            <input
                                              style={{ cursor: "pointer" }}
                                              type="checkbox"
                                              name={task.name}
                                              checked={selectedTTaskId.includes(
                                                task.id
                                              )}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, task.id)
                                              }
                                            />
                                          </td>
                                        )}
                                        <td>{task.name}</td>
                                        <td
                                          style={{
                                            paddingTop: "0px",
                                            paddingBottom: "0px",
                                          }}
                                        >
                                          {hasPermission(
                                            "projects",
                                            "update"
                                          ) ? (
                                            <MultiSelect
                                              options={options}
                                              value={
                                                task?.assigned_users?.map(
                                                  (user) => ({
                                                    label: user.label,
                                                    value: parseInt(
                                                      user.value,
                                                      10
                                                    ),
                                                  })
                                                ) || []
                                              }
                                              onChange={(selected) =>
                                                handleTaskUser(
                                                  task.id,
                                                  selected
                                                )
                                              }
                                              labelledBy="Select Users"
                                              className="task-assigned-user"
                                            />
                                          ) : (
                                            <ul
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                listStyle: "none", // Removes bullet points
                                                padding: 0, // Resets padding for consistency
                                              }}
                                            >
                                              {task?.assigned_users
                                                ?.slice(0, 4)
                                                .map((user, index, arr) => (
                                                  <li
                                                    key={user.value}
                                                    style={{
                                                      marginRight:
                                                        index < arr.length - 1
                                                          ? "5px"
                                                          : "0",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    {user.label}
                                                    {index < arr.length - 1 &&
                                                      ","}
                                                  </li>
                                                ))}
                                              {task?.assigned_users?.length >
                                                4 && (
                                                <li
                                                  style={{
                                                    marginLeft: "5px",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  +{" "}
                                                  {task.assigned_users.length -
                                                    4}{" "}
                                                  more
                                                </li>
                                              )}
                                            </ul>
                                          )}
                                        </td>
                                        <td style={{ padding: "0px" }}>
                                          <DatePicker
                                            placeholderText="Start Date"
                                            className="task-date-input"
                                            selected={
                                              task.start_date
                                                ? parseISO(task.start_date)
                                                : null
                                            }
                                            dateFormat="dd-MM-yyyy"
                                            onChange={(date) =>
                                              handleDateChange(
                                                taskTemplate.id,
                                                task.id,
                                                "start_date",
                                                format(date, "yyyy-MM-dd")
                                              )
                                            }
                                            minDate={project_start_date}
                                            maxDate={project_due_date}
                                            disabled={
                                              !hasPermission(
                                                "projects",
                                                "update"
                                              )
                                            }
                                          />
                                        </td>

                                        <td style={{ padding: "0px" }}>
                                          <DatePicker
                                            placeholderText="Due Date"
                                            className="task-date-input"
                                            selected={
                                              task.due_date
                                                ? parseISO(task.due_date)
                                                : null
                                            }
                                            dateFormat="dd-MM-yyyy"
                                            onChange={(date) => {
                                              handleDateChange(
                                                taskTemplate.id,
                                                task.id,
                                                "due_date",
                                                format(date, "yyyy-MM-dd")
                                              );
                                            }}
                                            minDate={project_start_date}
                                            maxDate={project_due_date}
                                            disabled={
                                              !hasPermission(
                                                "projects",
                                                "update"
                                              )
                                            }
                                          />
                                        </td>

                                        <td
                                          style={{
                                            padding: "0px",
                                            width: "110px",
                                          }}
                                        >
                                          <div className="task-planned-hours">
                                            <input
                                              type="text"
                                              defaultValue={
                                                task.planned_hours === "00:00"
                                                  ? ""
                                                  : task.planned_hours
                                              }
                                              onChange={(e) =>
                                                handlePlannedHoursChange(
                                                  task.id,
                                                  e,
                                                  taskTemplate.id
                                                )
                                              }
                                              onBlur={() =>
                                                handleSavePlannedHours(task.id)
                                              }
                                              placeholder={"Total PHrs"}
                                              className="planned-hous-phase-input"
                                              disabled={
                                                !hasPermission(
                                                  "projects",
                                                  "update"
                                                )
                                              }
                                              style={{
                                                cursor: hasPermission(
                                                  "projects",
                                                  "update"
                                                )
                                                  ? "pointer"
                                                  : "not-allowed",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <input
                                            type="text"
                                            defaultValue={task.actualhours}
                                            disabled
                                            placeholder="Actual hours"
                                            className="planned-hous-phase-input"
                                            style={{ cursor: "not-allowed" }}
                                          />
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            color:
                                              task.planned_hours &&
                                              task.actualhours
                                                ? convertTimeToMinutes(
                                                    task.planned_hours
                                                  ) -
                                                    convertTimeToMinutes(
                                                      task.actualhours
                                                    ) >=
                                                  0
                                                  ? "green"
                                                  : "red"
                                                : "inherit",
                                          }}
                                        >
                                          {task.planned_hours &&
                                          task.actualhours
                                            ? convertMinutesToHHMM(
                                                convertTimeToMinutes(
                                                  task.planned_hours
                                                ) -
                                                  convertTimeToMinutes(
                                                    task.actualhours
                                                  )
                                              )
                                            : ""}
                                        </td>
                                        <td></td>
                                      </tr>
                                    ))}
                              </tbody>
                            </table>
                            {hasPermission("projects", "update") && (
                              <button
                                className="add-general-btn"
                                onClick={() => {
                                  setAddTaskDial(true);
                                  setTaskTemplateIdToAdd(taskTemplate.id);
                                }}
                              >
                                Add Task
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="phase-image-container">
                      <img
                        className="phase-image-variations"
                        src="/AppLayout/variation.png"
                      />
                      <p className="phase-message-variations">
                        No tasks associated with this phase.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {tabIndex === 1 && (
              <Box>
                <>
                  {variationToBulkUpdate.length > 0 && (
                    <button
                      onClick={() => setBulkActionVariation((prev) => !prev)}
                      className="add-btn mass-update-var-issue"
                    >
                      Mass Update
                    </button>
                  )}
                  {hasPermission("variations", "create") && (
                    <>
                      {hasPermission("variations", "delete") && (
                        <button
                          onClick={() => setShowModal(true)}
                          className="export-issue"
                        >
                          Export
                        </button>
                      )}
                      <button
                        onClick={handleOpenVariationDialog}
                        className="add-btn variation-btn"
                        title="New Variation"
                      >
                        New Variation
                      </button>
                    </>
                  )}
                </>

                {variations.length === 0 && (
                  <div className="phase-image-container">
                    <img
                      className="phase-image-variations"
                      src="/AppLayout/variation.png"
                    />
                    <p className="phase-message-variations">
                      No variation available for this project
                    </p>
                  </div>
                )}

                {variations.length !== 0 && (
                  <div
                    className={
                      isNavBarOpen
                        ? "var-table-wrapper"
                        : "var-table-wrapper-close"
                    }
                  >
                    <div
                      className={
                        isNavBarOpen
                          ? "variation-table-container"
                          : "variation-table-container-close"
                      }
                    >
                      <table
                        className={
                          isNavBarOpen
                            ? "variation-table"
                            : "variation-table-close"
                        }
                      >
                        <thead>
                          <tr>
                            {hasPermission("variations", "delete") && (
                              <th style={{ width: "2px", textAlign: "center" }}>
                                <FaChevronDown />
                              </th>
                            )}
                            <th style={{ width: "150px" }}>Date</th>
                            <th
                              style={{
                                width: "100px",
                                padding: "0px",
                                paddingLeft: "7px",
                              }}
                            >
                              Variation No
                            </th>
                            <th style={{ width: "150px" }}>Variation Title</th>
                            <th style={{ minWidth: "100px" }}>Description</th>
                            <th style={{ width: "100px" }}>DE PHrs</th>
                            <th style={{ width: "100px" }}>DE AHrs</th>
                            <th style={{ width: "100px" }}>DO PHrs</th>
                            <th style={{ width: "100px" }}>DO AHrs</th>
                            <th style={{ width: "100px" }}>Total PHrs</th>
                            <th style={{ width: "100px" }}>Total AHrs</th>
                            {(userDetails.role_name === "Administrator" ||
                              userDetails.role_name === "Super Admin") && (
                              <th style={{ width: "150px" }}>Claim Status</th>
                            )}
                            <th style={{ width: "150px" }}>Variation Status</th>
                            <th style={{ width: "150px" }}>Created By</th>
                            <th style={{ width: "150px" }}>Confirmed By</th>
                            {!allUnclaimed &&
                              (userDetails.role_name === "Administrator" ||
                                userDetails.role_name === "Super Admin") && (
                                <>
                                  <th style={{ width: "100px" }}>
                                    Invoice Date
                                  </th>
                                  <th style={{ width: "110px" }}>Invoice No</th>
                                </>
                              )}
                            <th style={{ width: "100%" }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {variations
                            .slice() // Create a copy to avoid mutating the original array
                            .sort((a, b) => {
                              const numA = a.variationno
                                ? parseInt(a.variationno.replace("VO-", ""), 10)
                                : Infinity;
                              const numB = b.variationno
                                ? parseInt(b.variationno.replace("VO-", ""), 10)
                                : Infinity;
                              return numA - numB;
                            })
                            .map((variation, index) => (
                              <tr key={index}>
                                {hasPermission("variations", "delete") && (
                                  <td>
                                    <input
                                      style={{ cursor: "pointer" }}
                                      type="checkbox"
                                      name={variation.name}
                                      checked={variationToBulkUpdate.includes(
                                        variation.id
                                      )}
                                      onChange={(e) =>
                                        handleDeleteVariation(e, variation.id)
                                      }
                                    />
                                  </td>
                                )}
                                <td>
                                  {variation.date
                                    ? format(variation.date, "dd-MM-yyyy")
                                    : null}
                                </td>
                                <td
                                  style={{
                                    minWidth: "90px",
                                    padding: "0px",
                                    paddingLeft: "7px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span style={{ marginTop: "6px" }}>
                                      {variation.variationno}
                                    </span>
                                    {(hasPermission("projects", "update") ||
                                      (variation.variation_status ===
                                        "Waiting" &&
                                        variation.created_by ===
                                          userDetails.id)) && (
                                      <button
                                        style={{
                                          width: "50px",
                                          border: "none",
                                          paddingRight: "50px",
                                          color: "#0000ff",
                                          backgroundColor: "transparent",
                                        }}
                                        onClick={() =>
                                          handleOpenEditVariationDialog(
                                            variation
                                          )
                                        }
                                        className="edit-icon-wrapper"
                                        title="Edit Variation"
                                      >
                                        <EditIcon />
                                      </button>
                                    )}
                                  </div>
                                </td>{" "}
                                <td
                                  style={{
                                    whiteSpace: "wrap",
                                    minWidth: "200px",
                                  }}
                                >
                                  {variation.name}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "wrap",
                                    minWidth: "300px",
                                    cursor: "pointer",
                                  }}
                                  title={variation.description}
                                >
                                  {variation.description}
                                </td>
                                <td
                                  style={{ width: "10px", textAlign: "center" }}
                                >
                                  {variation.design !== "00:00" &&
                                    variation.design}
                                </td>
                                <td
                                  style={{
                                    width: "10px",
                                    textAlign: "center",
                                    color:
                                      convertTimeToMinutes(variation.design) <
                                      convertTimeToMinutes(
                                        variation.designActual
                                      )
                                        ? "red"
                                        : "green",
                                  }}
                                >
                                  {variation.designActual !== "00:00" &&
                                    variation.designActual}
                                </td>
                                <td
                                  style={{ width: "10px", textAlign: "center" }}
                                >
                                  {variation.detailing !== "00:00" &&
                                    variation.detailing}
                                </td>
                                <td
                                  style={{
                                    width: "10px",
                                    textAlign: "center",
                                    color:
                                      convertTimeToMinutes(
                                        variation.detailing
                                      ) <
                                      convertTimeToMinutes(
                                        variation.detailingActual
                                      )
                                        ? "red"
                                        : "green",
                                  }}
                                >
                                  {variation.detailingActual !== "00:00" &&
                                    variation.detailingActual}
                                </td>
                                <td
                                  style={{ width: "10px", textAlign: "center" }}
                                >
                                  {variation.plannedhours !== "00:00" &&
                                    variation.plannedhours}
                                </td>
                                <td
                                  style={{
                                    width: "10px",
                                    textAlign: "center",
                                    color:
                                      convertTimeToMinutes(
                                        variation.plannedhours
                                      ) <
                                      convertTimeToMinutes(
                                        variation.actualhours
                                      )
                                        ? "red"
                                        : "green",
                                  }}
                                >
                                  {variation.actualhours !== "00:00" &&
                                    variation.actualhours}
                                </td>
                                {(userDetails.role_name === "Administrator" ||
                                  userDetails.role_name === "Super Admin") && (
                                  <td
                                    style={{
                                      backgroundColor:
                                        variation.invoice_status === "Claimed"
                                          ? "white"
                                          : "null",
                                      color: "white",
                                      width: "140px",
                                      textAlign: "center",
                                      fontWeight: "500",
                                    }}
                                  >
                                    <select
                                      style={{
                                        border: "none",
                                        backgroundColor: getColorValue(
                                          variation.invoice_status
                                        ),
                                        color: "white",
                                        borderRadius: "3px",
                                        paddingLeft: "8px",
                                        paddingRight: "3px",
                                        fontWeight: "500",
                                        cursor: !hasPermission(
                                          "variations",
                                          "update"
                                        )
                                          ? "not-allowed"
                                          : "pointer",
                                        outline: "none",
                                        height: "25px",
                                        fontFamily: '"Lato", sans-serif',
                                        fontSize: "12.5px",
                                        width: "82px",
                                        textAlign: "center",
                                      }}
                                      onChange={
                                        (e) =>
                                          updateClaimStatus(
                                            variation.id,
                                            e.target.value,
                                            "status"
                                          ) // Update only the status
                                      }
                                      value={variation.invoice_status}
                                      disabled={
                                        !hasPermission("variations", "update")
                                      }
                                    >
                                      <option
                                        style={{
                                          backgroundColor: "white",
                                          color: "black",
                                          fontWeight: "500",
                                        }}
                                        value="Unclaimed"
                                      >
                                        Unclaimed
                                      </option>
                                      <option
                                        style={{
                                          backgroundColor: "white",
                                          color: "black",
                                          fontWeight: "500",
                                        }}
                                        value="Claimed"
                                      >
                                        Claimed
                                      </option>
                                      <option
                                        style={{
                                          backgroundColor: "white",
                                          color: "black",
                                          fontWeight: "500",
                                        }}
                                        value="Ignored"
                                      >
                                        Ignored
                                      </option>
                                      <option
                                        style={{
                                          backgroundColor: "white",
                                          color: "black",
                                          fontWeight: "500",
                                        }}
                                        value="Expired"
                                      >
                                        Expired
                                      </option>
                                    </select>
                                  </td>
                                )}
                                <td>
                                  <select
                                    className="variation-status-dropdown"
                                    value={variation.variation_status}
                                    onChange={
                                      (e) =>
                                        updateClaimStatus(
                                          variation.id,
                                          e.target.value,
                                          "variation_status",
                                          userID
                                        ) // Update only the date
                                    }
                                    style={{
                                      backgroundColor: getColorForStatus(
                                        variation.variation_status
                                      ),
                                      cursor:
                                        !hasPermission(
                                          "variations",
                                          "update"
                                        ) ||
                                        (variation.variation_status ===
                                          "Approved" &&
                                          userDetails.role_name !==
                                            "Super Admin")
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                    disabled={
                                      !hasPermission("variations", "update") ||
                                      (variation.variation_status ===
                                        "Approved" &&
                                        userDetails.role_name !== "Super Admin")
                                    }
                                  >
                                    <option value={""} disabled>
                                      Select Status
                                    </option>
                                    <option
                                      value={"Approved"}
                                      disabled={
                                        userDetails.designation ===
                                        "Document Controller"
                                      }
                                    >
                                      Approved
                                    </option>
                                    <option
                                      value={"Confirmed"}
                                      disabled={
                                        userDetails.designation ===
                                        "Document Controller"
                                      }
                                    >
                                      Confirmed
                                    </option>
                                    <option
                                      value={"Hold"}
                                      disabled={
                                        userDetails.designation ===
                                        "Document Controller"
                                      }
                                    >
                                      Hold
                                    </option>
                                    <option
                                      value={"Accepted"}
                                      disabled={
                                        userDetails.designation ===
                                        "Document Controller"
                                      }
                                    >
                                      Accepted
                                    </option>
                                    <option value={"Verified"}>Verified</option>
                                    <option value={"Rejected"}>Rejected</option>
                                    <option value={"Waiting"}>Waiting</option>
                                  </select>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  title={
                                    variation.created_at
                                      ? format(
                                          variation.created_at,
                                          "dd-MM-yyyy HH:mm"
                                        )
                                      : ""
                                  }
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {variation.created_by_name}
                                    {/* <span className="text-[10px] text-gray-500">
                                      {variation.created_at
                                        ? format(
                                            variation.created_at,
                                            "dd-MM-yyyy HH:mm"
                                          )
                                        : ""}
                                    </span> */}
                                  </div>
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  title={
                                    variation.approved_at
                                      ? format(
                                          variation.approved_at,
                                          "dd-MM-yyyy HH:mm"
                                        )
                                      : ""
                                  }
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {variation.approved_by_name}
                                    {/* <span className="text-[10px] text-gray-500">
                                      {variation.approved_at
                                        ? format(
                                            variation.approved_at,
                                            "dd-MM-yyyy HH:mm"
                                          )
                                        : ""}
                                    </span> */}
                                  </div>
                                </td>
                                {!allUnclaimed &&
                                  (userDetails.role_name === "Administrator" ||
                                    userDetails.role_name ===
                                      "Super Admin") && (
                                    <>
                                      <td>
                                        <DatePicker
                                          onChange={
                                            (date) =>
                                              updateClaimStatus(
                                                variation.id,
                                                date,
                                                "date"
                                              ) // Update only the date
                                          }
                                          selected={
                                            variation.invoice_date &&
                                            isValid(
                                              new Date(variation.invoice_date)
                                            )
                                              ? new Date(variation.invoice_date)
                                              : null
                                          }
                                          disabled={
                                            variation.invoice_status ===
                                              "Unclaimed" ||
                                            !hasPermission("invoices", "update")
                                          }
                                          placeholderText="Select Date"
                                          className="invoice-input"
                                          dateFormat="dd-MM-yyyy"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          value={variation.invoice_no}
                                          className="invoice-element"
                                          placeholder="Enter Invoice No"
                                          type="text"
                                          onChange={(e) =>
                                            setVariations((prev) =>
                                              prev.map((v) =>
                                                v.id === variation.id
                                                  ? {
                                                      ...v,
                                                      invoice_no:
                                                        e.target.value,
                                                    }
                                                  : v
                                              )
                                            )
                                          }
                                          onBlur={
                                            (e) =>
                                              updateClaimStatus(
                                                variation.id,
                                                e.target.value,
                                                "number"
                                              ) // Update only the date
                                          }
                                          style={{
                                            cursor: !hasPermission(
                                              "projects",
                                              "update"
                                            )
                                              ? "not-allowed"
                                              : "",
                                            width: "110px",
                                          }}
                                          disabled={
                                            variation.invoice_status ===
                                              "Unclaimed" ||
                                            !hasPermission("invoices", "update")
                                          }
                                        />
                                      </td>
                                    </>
                                  )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div
                        className={
                          isNavBarOpen
                            ? "variation-summary"
                            : "variation-summary-close"
                        }
                      >
                        <p className="variation-para-hours">
                          Total Variation Hours: {formattedTotalVariationHours}
                        </p>
                        <p className="variation-para">
                          Total No of Variations: {variations.length}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {bulkActionVariation && (
                  <div className="action-box-variation" ref={variationRef}>
                    {hasPermission("projects", "delete") &&
                      variationToBulkUpdate.length > 0 && (
                        <button
                          className="add-btn"
                          onClick={() => setDeleteDialogOpen(true)}
                          title="Delete Variation"
                          style={{
                            backgroundColor: "red",
                            fontFamily: '"Lato", sans-serif',
                            fontSize: "13px",
                            cursor: "pointer",
                          }}
                        >
                          Delete
                        </button>
                      )}
                    {hasPermission("projects", "update") && (
                      <button
                        onClick={() => setClaimStatusVariation((prev) => !prev)}
                        className="add-btn"
                        style={{
                          textWrap: "nowrap",
                          fontFamily: '"Lato", sans-serif',
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                      >
                        Claim Status
                      </button>
                    )}
                    {claimStatusVariation &&
                      hasPermission("projects", "update") && (
                        <select
                          onChange={(e) =>
                            updateBulkVariationClaimStatus(
                              variationToBulkUpdate,
                              e.target.value
                            )
                          }
                          className="bulk-select"
                        >
                          <option>Select Claim Status</option>
                          <option value="Claimed">Claimed</option>
                          <option value="Unclaimed">Unclaimed</option>
                          <option value="Ignored"> Ignored</option>
                          <option value="Expired"> Expired</option>
                        </select>
                      )}
                  </div>
                )}
              </Box>
            )}
            {/*Issue tab*/}
            {tabIndex === 2 && (
              <Box>
                <>
                  {issueToDelete.length > 0 && (
                    <button
                      onClick={() => setBulkAction((prev) => !prev)}
                      className="add-btn mass-update-var-issue"
                    >
                      Mass Update
                    </button>
                  )}

                  {hasPermission("issues", "create") && (
                    <>
                      {hasPermission("issues", "delete") && (
                        <button
                          onClick={exportToExcel}
                          className="export-issue"
                        >
                          Export to Excel
                        </button>
                      )}
                      <button
                        onClick={handleOpenIssueDialog}
                        style={{ textWrap: "nowrap", width: "auto" }}
                        className="add-btn add-issue-btn"
                        title="New Issue"
                      >
                        New Issue
                      </button>
                    </>
                  )}
                </>
                {issues.length === 0 && (
                  <div className="phase-image-container">
                    <img
                      className="phase-image-issues"
                      src="/AppLayout/Issue.png"
                    />
                    <p className="phase-message-issues">
                      No issue available for this project
                    </p>
                  </div>
                )}

                {issues.length !== 0 && (
                  <div
                    className={
                      isNavBarOpen
                        ? "var-table-wrapper"
                        : "var-table-wrapper-close"
                    }
                  >
                    <div
                      className={
                        isNavBarOpen
                          ? "variation-table-container"
                          : "variation-table-container-close"
                      }
                    >
                      <table
                        className={
                          isNavBarOpen
                            ? "variation-table"
                            : "variation-table-close"
                        }
                      >
                        <thead>
                          <tr>
                            {hasPermission("issues", "delete") && (
                              <th style={{ width: "2px", textAlign: "center" }}>
                                <FaChevronDown />
                              </th>
                            )}
                            <th style={{ width: "100px" }}>Date</th>
                            <th style={{ width: "100px" }}>Issue No</th>
                            <th style={{ width: "100px" }}>Issue Name</th>
                            <th style={{ width: "100px" }}>Category</th>
                            <th style={{ width: "100px" }}>Vo Title</th>
                            <th style={{ width: "100px" }}>Issue Type</th>
                            <th style={{ width: "150px" }}>Raised By</th>
                            <th style={{ width: "150px" }}>Error By</th>
                            <th style={{ width: "150px" }}>Attended By</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {issues.map((issue, index) => (
                            <tr key={index}>
                              {hasPermission("issues", "delete") && (
                                <td>
                                  <input
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    name={issue.name}
                                    checked={issueToDelete.includes(issue.id)} // Make sure this works properly
                                    onChange={(e) =>
                                      handleDeleteIssue(e, issue.id)
                                    }
                                  />
                                </td>
                              )}
                              <td>
                                {issue.date
                                  ? format(issue.date, "dd-MM-yyyy")
                                  : null}
                              </td>
                              <td style={{ whiteSpace: "nowrap" }}>
                                {" "}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span style={{ marginTop: "6px" }}>
                                    {issue.issue_number}
                                  </span>
                                  {hasPermission("issues", "update") && (
                                    <button
                                      style={{
                                        width: "50px",
                                        border: "none",
                                        paddingRight: "50px",
                                        color: "#0000ff",
                                        backgroundColor: "transparent",
                                      }}
                                      onClick={() =>
                                        handleOpenEditIssueDialog(issue)
                                      }
                                      className="edit-icon-wrapper"
                                      title="Edit Issue"
                                    >
                                      <EditIcon />
                                    </button>
                                  )}{" "}
                                </div>
                              </td>{" "}
                              <td style={{ whiteSpace: "nowrap" }}>
                                {issue.name}
                              </td>
                              <td>
                                {issue.category.charAt(0).toUpperCase() +
                                  issue.category.slice(1)}
                              </td>
                              <td>{issue.variation_name}</td>
                              <td
                                style={{ width: "10px", textAlign: "center" }}
                              >
                                {issue.type.charAt(0).toUpperCase() +
                                  issue.type.slice(1)}
                              </td>
                              <td>{issue.raisedby_name}</td>
                              <td>
                                <ul
                                  style={{
                                    margin: "0px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {issue.errorby_names?.map(
                                    (user, index, arr) => (
                                      <li>{user},</li>
                                    )
                                  )}
                                </ul>
                              </td>
                              <td>
                                <ul
                                  style={{
                                    margin: "0px",
                                    marginTop: "5px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {issue.attendedby_names?.map(
                                    (user, index, arr) => (
                                      <li>
                                        {user},{""}{" "}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </td>
                              <td></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="issue-summary">
                        <p className="issue-para">
                          Total No of Issues: {issues.length}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {/* </div> */}
                {bulkAction && (
                  <div
                    className="action-box-variation action-box-issue"
                    ref={issueRef}
                  >
                    {hasPermission("projects", "delete") && (
                      <button
                        className="add-btn"
                        onClick={() => setDeleteIssueDialogOpen(true)}
                        title="Delete Issue"
                        style={{ backgroundColor: "red" }}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                )}
              </Box>
            )}
          </div>
        </div>
      )}
      {/* Delete Confirmation Dialog */}
      {deleteIssueDialogOpen && (
        <div className="delete-issue-dial">
          <div className="delete-var-dial">
            <div className="delete-var-header">
              <h3 className="delete-variation">Delete Issue</h3>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <p className="delete-t-para">
                Are you sure you want to delete this issue? This action cannot
                be undone.
              </p>
              <input
                style={{
                  backgroundColor: "white",
                  cursor: "pointer",
                }}
                type="checkbox"
                id="tick-issue"
                checked={isIssueCheckboxChecked}
                onChange={() =>
                  setIsIssueCheckboxChecked(!isIssueCheckboxChecked)
                }
              />
              <label
                htmlFor="tick-issue"
                style={{
                  backgroundColor: "white",
                  userSelect: "none",
                  cursor: "pointer",
                }}
              >
                I understand this action cannot be undone.
              </label>
            </div>
            <div className="delete-btn-issue-del-con">
              <button
                onClick={handleDeleteIssueConfirm}
                color="primary"
                variant="contained"
                disabled={!isIssueCheckboxChecked}
                style={{
                  backgroundColor: isIssueCheckboxChecked ? "red" : "grey",
                }}
                className="add-btn"
              >
                Delete
              </button>
              <button
                onClick={() => {
                  setDeleteIssueDialogOpen(false);
                  setIsIssueCheckboxChecked(false);
                }}
                color="secondary"
                style={{ marginRight: "140px" }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Add/Edit Issue Dialog */}
      {openIssueDialog && (
        <div className="add-variation-dial">
          <div className="add-phase-con">
            <div className="dial-v-header">
              <h3 className="add-edit-variation">
                {isIssueEditMode ? "Edit Issue" : "Add Issue"}
              </h3>
            </div>
            <div className="add-variation-content">
              <h3 className="issue-label">Date</h3>
              <DatePicker
                selected={issueDate}
                onChange={(date) => setIssueDate(date)}
                dateFormat="dd-MM-yyyy"
                required
                className="variation-date"
              />
              <h3 className="issue-label">Issue No</h3>
              <input
                label="Issue No"
                className="issue-number"
                value={issueNo || ""}
                fullWidth
                onChange={(e) => setIssueNo(e.target.value)}
                margin="dense"
                disabled={isIssueEditMode} // Disable editing of issue number
              />
              <h3 className="issue-label">Issue Name</h3>
              <input
                label="Issue Name"
                className="issue-name"
                value={issueName || ""}
                fullWidth
                onChange={(e) => setIssueName(e.target.value)}
                margin="dense"
              />
              <h3 className="issue-label">Category</h3>
              <select
                className="issue-type"
                value={issueCategory}
                onChange={(e) => {
                  setIssueCategory(e.target.value);
                  setSelectedVartionIssue("");
                }}
              >
                <option value="" disabled>
                  Select Issue Category
                </option>
                <option value="general">General</option>
                <option value="variations">Variations</option>
              </select>
              {issueCategory === "variations" && (
                <>
                  <h3 className="issue-label">Select Variation</h3>
                  <select
                    className="issue-type"
                    value={selectedVartionIssue}
                    onChange={(e) => setSelectedVartionIssue(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Variation
                    </option>
                    {variations
                      .filter(
                        (v) =>
                          v.variation_status === "Approved" ||
                          v.variation_status === "Accepted" ||
                          v.variation_status === "Confirmed"
                      )
                      .map((option) => (
                        <option key={option.id} value={option.id}>
                          {`${option.variationno} - ${option.name}`}
                        </option>
                      ))}
                  </select>
                </>
              )}
              <h3 className="issue-label">Issue Type</h3>
              <select
                className="issue-type"
                value={issueType}
                onChange={(e) => setIssueType(e.target.value)}
              >
                <option value="" disabled>
                  Select Issue Type
                </option>
                <option value="internal">Internal</option>
                <option value="external">External</option>
              </select>
              <h3 className="issue-label">Raised By</h3>
              {issueType === "internal" ? (
                <select
                  className="issue-type"
                  value={issueRaisedBy}
                  onChange={(e) => setIssueRaisedBy(e.target.value)}
                >
                  <option>Select User</option>
                  {projectUsers
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                </select>
              ) : (
                <select
                  className="issue-type"
                  value={issueRaisedBy}
                  onChange={(e) => setIssueRaisedBy(e.target.value)}
                >
                  <option value={""}>Select Contact</option>
                  {Array.isArray(customer.contacts) &&
                    customer.contacts.map((contact) => (
                      <option
                        key={contact.contact_id}
                        value={contact.contact_id}
                      >
                        {contact.contact_name}
                      </option>
                    ))}
                </select>
              )}
              <h3 className="issue-label">Error By</h3>
              <MultiSelect
                className="multiselect-issue "
                options={
                  projectUsers && Array.isArray(projectUsers)
                    ? projectUsers.map((user) => ({
                        label: user.name, // Fallback for missing name
                        value: user.id, // The value that will be stored in `issueErrorBy`
                      }))
                    : [] // Fallback to an empty array if `users` is undefined or not an array
                }
                labelledBy="Select Users"
                value={issueErrorBy
                  .map((id) => {
                    const user = users.find((u) => u.id === id);
                    return user ? { label: user.name, value: user.id } : null;
                  })
                  .filter(Boolean)} // Remove any `null` values
                onChange={
                  (selected) =>
                    setIssueErrorBy(selected.map((item) => item.value)) // Update `issueErrorBy` with selected IDs
                }
              />
              <h3 className="issue-label">Attended By</h3>
              <MultiSelect
                className="multiselect-issue"
                options={
                  projectUsers && Array.isArray(users)
                    ? projectUsers.map((user) => ({
                        label: user.name, // Fallback for missing name
                        value: user.id, // The value that will be stored in `issueErrorBy`
                      }))
                    : [] // Fallback to an empty array if `users` is undefined or not an array
                }
                labelledBy="Select Users"
                value={issueAttendedBy
                  .map((id) => {
                    const user = users.find((u) => u.id === id);
                    return user ? { label: user.name, value: user.id } : null;
                  })
                  .filter(Boolean)} // Remove any `null` values
                onChange={
                  (selected) =>
                    setIssueAttendedBy(selected.map((item) => item.value)) // Update `issueErrorBy` with selected IDs
                }
              />
            </div>

            <div className={"add-issue-btn-con-second"}>
              <button
                onClick={isIssueEditMode ? handleSaveIssue : handleAddIssue}
                color="primary"
                variant="contained"
                className="add-edit-issue-btn"
              >
                {isIssueEditMode ? "Save" : "Add"}
              </button>
              <button
                onClick={() => {
                  setOpenIssueDialog(false);
                  setIssueAttendedBy([]);
                  setIssueErrorBy([]);
                  setIssueRaisedBy([]);
                  setIssueType([]);
                  setIssueCategory([]);
                  setSelectedVartionIssue([]);
                  setIssueDate("");
                }}
                color="secondary"
                className="cancel-btn"
                style={{ marginRight: "140px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Dialog */}
      {deleteDialogOpen && (
        <div className="delete-var-issue-dial">
          <div className="delete-var-dial">
            <div className="delete-var-header">
              <h3 className="delete-variation">Delete Variation</h3>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <p className="delete-t-para">
                Are you sure you want to delete this variation? This action
                cannot be undone.
              </p>
              <input
                style={{ cursor: "pointer" }}
                type="checkbox"
                checked={isCheckboxChecked}
                id="tick"
                onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
              />
              <label
                htmlFor="tick"
                style={{
                  backgroundColor: "white",
                  userSelect: "none",
                  cursor: "pointer",
                }}
              >
                I understand this action cannot be undone.
              </label>
            </div>
            <div className="delete-btn-issue-del-con">
              <button
                onClick={handleDeleteConfirm}
                color="secondary"
                variant="contained"
                disabled={!isCheckboxChecked}
                style={{
                  backgroundColor: isCheckboxChecked ? "red" : "grey",
                }}
                className="add-btn"
              >
                Delete
              </button>
              <button
                onClick={() => {
                  setDeleteDialogOpen(false);
                  setIsCheckboxChecked(false);
                  setVariationToBulkUpdate([]);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/*add variation dial box*/}
      {openVariationDialog && (
        <div className="add-variation-dial">
          <div className="add-phase-con">
            <div className="dial-v-header">
              <h3 className="add-edit-variation">
                {isEditMode ? "Edit Variation" : "Add Variation"}
              </h3>
            </div>
            <div className="add-variation-content">
              <h3 className="variation-label">Date</h3>
              <DatePicker
                selected={variationDate}
                onChange={(date) => setVariationDate(date)}
                dateFormat="dd-MM-yyyy"
                required
                className="variation-date"
              />

              <h3 className="variation-label">Variation No</h3>
              <input
                label="Variation No"
                value={variationNo || ""}
                fullWidth
                onChange={(e) => setVariationNo(e.target.value)}
                margin="dense"
                maxLength={"40"}
                className="variation-number"
              />
              <h3 className="variation-label">Variation Title</h3>
              <input
                label="Variation Title"
                value={variationName || ""}
                fullWidth
                maxLength={"70"}
                onChange={handleVariationNameChange}
                style={{
                  width: "100%",
                  border: showCapsWarning ? "1px solid red" : "1px solid #ccc",
                }}
                margin="dense"
                className="variation-name"
              />
              {showCapsWarning && (
                <p
                  style={{
                    color: "red",
                    fontSize: "0.9rem",
                    marginTop: "4px",
                  }}
                >
                  Please avoid using all capital letters. Use capitals only for
                  abbreviations.
                </p>
              )}

              <h3 className="variation-label">Description</h3>
              <textarea
                ref={textareaRef}
                label="Description"
                placeholder="Enter Description"
                value={variationDescription || ""}
                fullWidth
                maxLength={"200"}
                style={{
                  width: "100%",
                  border: showDescriptionCapsWarning
                    ? "1px solid red"
                    : "1px solid #ccc",
                }}
                onChange={handleVariationDescriptionChange}
                margin="dense"
                className="variation-name"
              />
              {showDescriptionCapsWarning && (
                <p
                  style={{
                    color: "red",
                    fontSize: "0.9rem",
                    marginTop: "4px",
                  }}
                >
                  Please avoid using all capital letters. Use capitals only for
                  abbreviations.
                </p>
              )}
              <h3 className="variation-label">
                Variation Hours : {variationHours !== 0 && variationHours}
              </h3>
              {!isEditMode && (
                <div className="add-variation-hours-con">
                  {variationTemplate.map((template, index) => (
                    <div key={index}>
                      <select
                        className="add-variation-select-template"
                        value={template.id}
                        onChange={(e) =>
                          handleTemplateChange(index, "name", e.target.value)
                        }
                      >
                        <option value="">Select Template</option>
                        {projectTemplates.map((task) => (
                          <option key={task.id} value={task.name}>
                            {task.name}
                          </option>
                        ))}
                      </select>

                      <input
                        placeholder="00:00"
                        type="text"
                        value={template.hours}
                        onChange={(e) =>
                          handleTemplateChange(index, "hours", e.target.value)
                        }
                        onBlur={(e) => {
                          handleTemplateChange(
                            index,
                            "hours",
                            normalizePlannedHours(e.target.value)
                          );
                          handleAddVariationHours();
                        }}
                        className="variation-hours"
                      />
                    </div>
                  ))}
                  {projectTemplates.length !== variationTemplate.length && (
                    <LuCirclePlus
                      onClick={handleAddTemplate}
                      className="add-variation-plus-template"
                    />
                  )}
                </div>
              )}
              {isEditMode && (
                <div>
                  {designHours !== "00:00" &&
                    templateName.includes("Design") && (
                      <div className="edit-template-hours">
                        <h3 className="variation-label">Design Hours</h3>
                        <input
                          placeholder="00:00"
                          type="text"
                          value={designHours || ""}
                          onChange={(e) => setDesignHours(e.target.value)}
                          onBlur={(e) => {
                            setDesignHours(
                              normalizePlannedHours(e.target.value)
                            );
                          }}
                          fullWidth
                          margin="dense"
                          className="variation-des-hours"
                        />
                        {templateName.includes("Detailing") && (
                          <CiCircleMinus
                            className="design-minus"
                            onClick={() => {
                              {
                                setDesignHours("00:00");
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                  {detailingHours !== "00:00" &&
                    templateName.includes("Detailing") && (
                      <div className="edit-template-hours">
                        <h3 className="variation-label">Detailing Hours</h3>
                        <input
                          placeholder="00:00"
                          type="text"
                          value={detailingHours || ""}
                          onChange={(e) => setDetailingHours(e.target.value)}
                          onBlur={(e) => {
                            setDetailingHours(
                              normalizePlannedHours(e.target.value)
                            );
                          }}
                          fullWidth
                          margin="dense"
                          className="variation-det-hours"
                        />
                        {templateName.includes("Design") && (
                          <CiCircleMinus
                            className="detailing-minus"
                            onClick={() => {
                              setDetailingHours("00:00");
                            }}
                          />
                        )}
                      </div>
                    )}
                  {((templateName.includes("Detailing") &&
                    detailingHours === "00:00") ||
                    (templateName.includes("Design") &&
                      designHours === "00:00")) && (
                    <LuCirclePlus
                      onClick={showTemplateHours}
                      className={
                        templateName.includes("Detailing") &&
                        detailingHours === "00:00" &&
                        templateName.includes("Design") &&
                        designHours === "00:00"
                          ? "plus-v-icon"
                          : "add-variation-template edit-variation-template"
                      }
                    />
                  )}
                </div>
              )}
            </div>

            <div className={"add-variation-btn-con-second"}>
              <button
                onClick={handleSaveOrAddVariation}
                style={{ marginLeft: "21px" }}
                color="primary"
                variant="contained"
                className="add-edit-issue-btn"
              >
                {isEditMode ? "Save" : "Add"}
              </button>
              <button
                onClick={() => {
                  setOpenVariationDialog(false);
                  setVariationName("");
                  setVariationNo("");
                  setVariationDescription("");
                  setVariationHours("");
                  setVariationTemplate([{ name: "", hours: "" }]);
                  setVariationDate("");
                  setShowCapsWarning(false);
                  setShowDescriptionCapsWarning(false);
                }}
                color="secondary"
                className="cancel-btn"
                style={{ marginRight: "140px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteTaskDialogOpen && (
        <div className="delete-var-issue-dial">
          <div className="delete-var-dial">
            <div className="delete-var-header">
              <h3 className="delete-variation">Delete Task Template</h3>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <p className="delete-t-para">
                Are you sure you want to delete this Task Template? This action
                cannot be undone.
              </p>
              <input
                style={{ cursor: "pointer" }}
                type="checkbox"
                checked={isCheckboxChecked}
                id="tick"
                onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
              />
              <label
                htmlFor="tick"
                style={{
                  backgroundColor: "white",
                  userSelect: "none",
                  cursor: "pointer",
                }}
              >
                I understand this action cannot be undone.
              </label>
            </div>
            <div className="delete-btn-issue-del-con">
              <button
                onClick={handleDeleteTaskTemplate}
                color="secondary"
                variant="contained"
                disabled={!isCheckboxChecked}
                style={{
                  backgroundColor: isCheckboxChecked ? "red" : "grey",
                }}
                className="add-btn"
              >
                Delete
              </button>
              <button
                onClick={() => {
                  setDeleteTaskDialogOpen(false);
                  setIsCheckboxChecked(false);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteIndividualTaskDialogOpen && (
        <div className="delete-var-issue-dial">
          <div className="delete-var-dial">
            <div className="delete-var-header">
              <h3 className="delete-variation">Delete Task</h3>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <p className="delete-t-para">
                Are you sure you want to delete this Task? This action cannot be
                undone.
              </p>
              <input
                style={{ cursor: "pointer" }}
                type="checkbox"
                checked={isCheckboxCheckedForTask}
                id="tick"
                onChange={() =>
                  setIsCheckboxCheckedForTask(!isCheckboxCheckedForTask)
                }
              />
              <label
                htmlFor="tick"
                style={{
                  backgroundColor: "white",
                  userSelect: "none",
                  cursor: "pointer",
                }}
              >
                I understand this action cannot be undone.
              </label>
            </div>
            <div className="delete-btn-issue-del-con">
              <button
                onClick={handleDeleteAssociatedTask}
                color="secondary"
                variant="contained"
                disabled={!isCheckboxCheckedForTask}
                style={{
                  backgroundColor: isCheckboxCheckedForTask ? "red" : "grey",
                }}
                className="add-btn"
              >
                Delete
              </button>
              <button
                onClick={() => {
                  setIndividualDeleteTaskDialogOpen(false);
                  setIsCheckboxCheckedForTask(false);
                }}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {addTaskDial && (
        <div className="add-phasetask-dial">
          <div className="add-role-settings">
            <div className="add-role-header">
              <h3 className="add-new-user-heading">Add Task</h3>
            </div>
            <h3 className="label-header-element">Task Name</h3>
            <input
              className="user-element"
              placeholder="Enter Task Name"
              type="text"
              value={newTask.name}
              onChange={(e) => setNewTask({ name: e.target.value })}
            />
            <div className="task-btn-container">
              <button className="add-btn" onClick={handleAddNewTask}>
                Add
              </button>
              <button
                className="cancel-btn"
                onClick={() => {
                  setAddTaskDial(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <div className="filter-var-dial ">
          <div className="modal-dial">
            <h3 className="var-xl-xport-header">Select Headers to Export</h3>
            <div className="checkbox-group">
              {availableHeaders.map((header) => (
                <label
                  key={header.key}
                  className="project-col-header-container"
                >
                  <div
                    className="project-column-swap"
                    style={{ width: "150px" }}
                  >
                    <input
                      style={{ cursor: "pointer" }}
                      type="checkbox"
                      checked={selectedHeaders.includes(header.key)}
                      onChange={() => toggleHeaderSelection(header.key)}
                    />
                    {header.label}
                  </div>
                </label>
              ))}
            </div>
            <div className="modal-actions">
              <button
                onClick={exportToExcelVariation}
                className="export-btn var-xl-export"
              >
                Excel
              </button>
              <button
                onClick={exportToPDFVariation}
                className="export-btn var-xl-export"
              >
                PDF
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="cancel-btn var-can-xl-export"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default PhaseDetails;
